var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _rect, _rect2, _rect3, _path317, _path318, _path319, _path320, _path321, _rect4, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1712(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hauser_RGB",
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.564,
    height: 80,
    viewBox: "0 0 165.564 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M331.935,170.921c.043,0,.082-.008.125-.008a2.663,2.663,0,0,1-.55-.023A2.7,2.7,0,0,0,331.935,170.921Z",
    transform: "translate(-202.254 -104.26)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M212.34,174.66h0q12.3,0,24.587.99Q224.645,174.662,212.34,174.66Z",
    transform: "translate(-129.548 -106.56)",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M253.252,147.29c-.055,0-.1.008-.152.008.14,0,.285-.008.444,0C253.443,147.294,253.346,147.29,253.252,147.29Z",
    transform: "translate(-154.416 -89.861)",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M220.241,146.25a3.162,3.162,0,0,0-.331.027c.125-.012.25-.027.382-.027Z",
    transform: "translate(-134.167 -89.227)",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M278.054,139.718q-13.838-1.842-27.734-2.488Q264.21,137.873,278.054,139.718Z",
    transform: "translate(-152.72 -83.724)",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M70.375,146.21c-3.232.5-6.461,1.033-9.685,1.634C63.914,147.243,67.143,146.709,70.375,146.21Z",
    transform: "translate(-37.027 -89.202)",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M339.064,146.4q-7.936-1.48-15.9-2.554Q331.126,144.932,339.064,146.4Z",
    transform: "translate(-197.159 -87.763)",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M220.761,161.719a3.907,3.907,0,0,0,.409-.039,4.394,4.394,0,0,1-.441.039h.035Z",
    transform: "translate(-134.667 -98.641)",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M251.841,162.728c.031,0,.055-.008.086-.008-.121,0-.242.008-.367,0C251.654,162.724,251.751,162.728,251.841,162.728Z",
    transform: "translate(-153.476 -99.275)",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M305.68,95.56l.671.667h.737l-.671-.667Z",
    transform: "translate(-186.495 -58.301)",
    fill: "#093266"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M309.61,95.56l.667.667h.741l-.671-.667Z",
    transform: "translate(-188.893 -58.301)",
    fill: "#093266"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M304,96.44h.53l-.53-.53Z",
    transform: "translate(-185.47 -58.515)",
    fill: "#093266"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M383.253,93.32c-.156.125-.316.238-.483.351a.41.41,0,0,0,.043-.027L384.1,94.93c.226-.016.452-.039.667-.074l-1.525-1.525.012-.012Z",
    transform: "translate(-233.527 -56.934)",
    fill: "#093266"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M5.883,47.931l-.023,18,17.631,2.129q2.339-.48,4.683-.928-.468-2.445-.936-4.893c3.224-.6,6.453-1.135,9.685-1.634a322.633,322.633,0,0,1,34.615-3.5c1.677-.078,3.357-.125,5.034-.175.791-.023,1.579-.062,2.371-.082,1.587-.035,3.178-.043,4.765-.055.881-.008,1.762-.031,2.644-.031h0c1.758,0,3.513.031,5.271.062.714.012,1.427.008,2.141.023,2.215.051,4.429.133,6.64.23.257.012.511.016.768.027q13.89.643,27.734,2.488l.663.094q7.966,1.082,15.9,2.554-.468,2.445-.936,4.893c1.56.3,3.115.608,4.671.924l17.643-2.133V16.076L86.382,5.9,5.926,16.084,5.907,30.23M29.675,46.653,26.743,43.72v-.8l2.932,2.932Zm0-1.532-2.932-2.932V41.4l2.932,2.928v.8Zm14.5,5.3L41.24,47.487v-.8l2.932,2.932v.791Zm11.178-1.08q-1.468-1.468-2.932-2.932v-.8q1.462,1.468,2.932,2.932Zm13.588,1.322-2.932-2.928v-.792l2.932,2.932v.792ZM104.7,52.7l-2.944-2.948c.261,0,.519-.008.776-.019l2.944,2.944c-.253.008-.511.016-.776.019Zm1.478-.058L103.23,49.7c.25-.019.5-.039.733-.062l2.944,2.948c-.238.023-.483.043-.733.062Zm52.7-26.841h.519l.721.846.729-.846h.519v2.141h-.616V26.783l-.573.686h-.105l-.573-.686v1.162h-.616V25.8Zm.659,20.419L156.6,43.3l-.105-.9,2.928,2.928ZM156.537,25.8h1.825v.624h-.6v1.517h-.624V26.428h-.6V25.8ZM18.009,25.528h8.745V27.6l2.932,2.932v.792l-2.932-2.932v.737l2.932,2.932v.8l-2.932-2.936v.741l2.932,2.932v.168h2.819V25.528h8.749l2.932,2.948v.487l-2.932-2.928v.737L44.187,29.7v.792l-2.932-2.932V28.3l2.924,2.924c-.012.043-.019.086-.031.129,1.216-4.3,4.843-6.55,10.672-6.55,3.856,0,6.847,1.15,8.769,3.232-.027-.027-.047-.058-.074-.09-.012-.012-.039-.039-.016-.019-.043-.043-.082-.086-.121-.129q1.158,1.164,2.312,2.328a11.661,11.661,0,0,1,1.926,2.339l-2.9-2.9c-.035-.058-.078-.113-.113-.172a9.333,9.333,0,0,1,.815,1.751c-.023-.066-.035-.136-.062-.2L67.718,33.3V25.516h8.749L79.4,28.464v.452l-2.932-2.932v.741L79.4,29.653v.792l-2.932-2.928v.737L79.4,31.185v.792l-2.932-2.928v.741L79.4,32.721v.8l-2.932-2.932v.737L79.4,34.25v.8l-2.932-2.932v.741L79.4,35.786v.792l-2.932-2.932v.741L79.4,37.318v.8l-2.932-2.932v.737L79.4,38.851v.792q-1.468-1.462-2.932-2.932v.737q1.468,1.468,2.932,2.928v.8l-2.932-2.932v.737l2.9,2.909c1.232-.113,1.934-.7,1.934-2.749V25.512h8.749L92.82,28.3c-.035.047-.066.1-.1.148-.889-.889-1.782-1.782-2.671-2.667v2.269c.636.636,1.271,1.275,1.911,1.911-.023.066-.043.14-.062.211a6.985,6.985,0,0,1,.269-.745q-1.059-1.059-2.113-2.117v-.791L92.442,28.9c-.055.094-.1.195-.148.292,1.852-3.712,6.663-4.371,9.8-4.371a21.222,21.222,0,0,1,8.656,1.692l.667.331,2.273,2.285v.355l-2.367-2.371-.195.546,2.562,2.566v.792l-2.772-2.772-.195.546,2.936,2.936-.211.585-2.936-2.936-.195.546,2.936,2.936-.211.585-2.936-2.936-.195.542,2.936,2.936-.211.585L109.7,31.637l-.195.542,2.936,2.936-.211.585L109.3,32.764l.062-.175-.257.717,2.936,2.936-.211.585-2.936-2.936.148-.413-.324.9-.877-.522c-.027-.016-.058-.027-.09-.043.269.152.538.312.8.468l2.971,2.971-.5-.3c.885.889,1.794,1.766,2.659,2.675v.573c-.612-.616-1.228-1.228-1.84-1.844-.016-.039-.039-.078-.058-.117a8.1,8.1,0,0,1,.6,3.143v-.214l1.3,1.3V25.5h18.119l2.651,2.667v.62l-2.651-2.651v.741l2.651,2.651v.8l-2.651-2.651v.737l2.651,2.651v.792L131.806,29.2v.737l2.651,2.651V25.5h13.225a8.7,8.7,0,0,1,6.706,2.612c-.019-.023-.035-.047-.055-.07-.062-.066-.125-.136-.191-.2.667.671,1.333,1.345,2,2.016a10.269,10.269,0,0,1,2.378,3.072l-2.92-2.92c-.016-.031-.035-.062-.051-.094a8.114,8.114,0,0,1,.53,1.618c-.016-.066-.023-.136-.039-.2,0-.008-.016-.058,0-.016-.016-.058-.027-.113-.043-.172l2.928,2.928a8.754,8.754,0,0,1,.207,1l-2.928-2.928c0-.027-.012-.058-.016-.086a10.267,10.267,0,0,1,.121,1.369c0-.113,0-.226-.008-.343,0-.039,0-.078-.008-.117l2.932,2.928q.029.409.023.819l-2.932-2.932v-.039a7.774,7.774,0,0,1-.062.9c.008-.055.019-.109.023-.168l2.936,2.936c-.023.234-.055.468-.1.694l-2.94-2.936c.012-.062.016-.129.027-.191a7.767,7.767,0,0,1-.179.846c0-.019.012-.035.016-.051q1.468,1.468,2.932,2.936c-.055.2-.117.405-.187.6q-1.468-1.468-2.932-2.936c.043-.125.078-.253.117-.378a8.035,8.035,0,0,1-1,2.133c.051-.074.1-.144.148-.218.979.975,1.957,1.957,2.936,2.932a5.628,5.628,0,0,1-.32.476q-1.468-1.468-2.936-2.94c.047-.066.09-.136.136-.2a7.847,7.847,0,0,1-1.431,1.595c.074-.062.152-.125.226-.191l1.735,1.735.881-.289-.324.105-1.918-1.918q.193-.2.374-.421l2.936,2.936c-.055.066-.109.133-.168.2l2.031,2.043.055.472-2.928-2.928-.058-.487.359,3.061,2.928,2.928.105.9L156.814,45l-.039-.32.136,1.158,2.928,2.928.105.9-2.928-2.928.1.834,2.928,2.932.07.585-.183.09-2.94-2.94-.335.168c-.1.051-.214.094-.324.14.055-.023.109-.043.16-.066l2.944,2.94c-.179.086-.367.164-.558.234l-2.944-2.944c-.191.07-.386.133-.585.191a.092.092,0,0,0,.031-.008l2.944,2.948c-.2.062-.413.117-.628.168l-2.944-2.944c.125-.027.246-.066.37-.1a10.472,10.472,0,0,1-1.384.273c.133-.016.265-.027.4-.051l2.948,2.944c-.234.039-.468.066-.706.09l-2.948-2.948a.342.342,0,0,0,.062-.008,10.2,10.2,0,0,1-1.033.058c.094,0,.183,0,.277-.008l2.948,2.948c-.269.008-.534.008-.8-.008L151.929,49.3c.175.012.351.023.534.023a8.475,8.475,0,0,1-1.361-.109l2.948,2.948a8.037,8.037,0,0,1-1.037-.242l-2.959-2.955a8.125,8.125,0,0,0,.92.226.351.351,0,0,1,.062.012,8,8,0,0,1-2.273-.76c.008,0,.012.008.02.012l.047.023,2.971,2.971a13.723,13.723,0,0,1-3.614-2.819c-.745-.745-1.493-1.489-2.238-2.234l.195.183h0c.152.14.308.273.464.405a29.633,29.633,0,0,1-2.363-2.324c.195.211.4.421.6.636l-1.63-1.634v.741l2.932,2.932v.792L143.215,45.2v.737l2.932,2.932v.8l-2.932-2.932v.737l2.928,2.932v.8l-2.932-2.932V49l2.932,2.928v.031h-.764l-2.948-2.948h-.737l2.948,2.948h-.8L140.9,49.015h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.8l-2.948-2.948H137.1l2.948,2.948h-.8L136.3,49.015h-.737l2.948,2.948h-.8l-2.948-2.948h-.3V34.92l-2.651-2.651v.737l2.651,2.651v.312h-.483l-2.948-2.948H130.3l.772.772h.008v1.54l2.932,2.932v.792q-1.468-1.462-2.932-2.928v.737q1.462,1.468,2.932,2.932v.8q-1.468-1.462-2.932-2.932v2.273l2.932,2.928v.3l.456.46v.491L132.352,42v.737l2.113,2.117v.792l-2.117-2.117v.741l2.117,2.113v.8l-2.117-2.117v2.269l2.932,2.932v.791l-2.932-2.932v.737l2.932,2.932v.164h-.628L131.7,49.008h-.737l2.948,2.948h-.792l-2.948-2.948h-.737l2.948,2.948H131.6l-2.948-2.948h-.741l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.792l-2.948-2.948h-.737l2.948,2.948H127l-2.948-2.948h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948h-.792l-2.948-2.948h-.737l2.948,2.948h-.425L114,49.292c-.055.074-.113.144-.172.214L110.9,46.575a5.543,5.543,0,0,0,.335-.46l2.484,2.488V43.264l-1.3-1.3v-.183a11.517,11.517,0,0,1-.09,1.248c.016-.121.035-.242.047-.367l1.341,1.341v.8l-1.435-1.435c.016-.094.023-.191.039-.289a8.4,8.4,0,0,1-.234,1.139c.023-.078.051-.156.07-.238l1.56,1.56v.8l-1.743-1.743A.726.726,0,0,1,112,44.5c-.07.218-.148.437-.238.643,0-.008.008-.012.012-.019l1.946,1.946v.792l-2.207-2.2c.058-.105.109-.218.164-.331a6.175,6.175,0,0,1-1.24,1.755c.039-.039.082-.074.117-.113l2.936,2.936a5.483,5.483,0,0,1-.406.39l-2.936-2.94c.031-.027.062-.058.094-.09a6.222,6.222,0,0,1-.519.433l.019-.012,2.936,2.936c-.148.113-.308.222-.468.328l-2.94-2.94c.113-.07.218-.148.328-.222a7.518,7.518,0,0,1-1.01.6l.214-.105,2.94,2.94c-.172.094-.347.179-.53.265l-2.94-2.94c.094-.043.183-.09.273-.136a9.968,9.968,0,0,1-1.166.487c.125-.043.253-.086.374-.129l2.94,2.94c-.191.07-.386.14-.585.207l-2.94-2.944a.153.153,0,0,0,.023-.008c-.246.078-.5.148-.76.218.055-.016.113-.027.168-.043l2.944,2.944c-.207.055-.417.105-.636.156L105.967,49.3l.14-.035c-.261.062-.53.117-.811.164a.23.23,0,0,0,.055-.008l2.944,2.948c-.222.043-.452.078-.686.109l-2.948-2.948.37-.058a23.045,23.045,0,0,1-3.6.261c-.195,0-.4,0-.6-.008.074,0,.152.008.226.008l2.948,2.948c-.269,0-.546-.016-.823-.027L100.236,49.7c.078,0,.152,0,.226.008-.351-.016-.71-.035-1.064-.066a.222.222,0,0,1,.051,0l2.948,2.948c-.292-.023-.581-.051-.873-.078l-2.952-2.952H98.6c-.331-.035-.659-.078-.986-.121.039,0,.078.012.117.016l2.948,2.952c-.312-.043-.624-.09-.932-.136l-2.952-2.952a.98.98,0,0,0,.105.016c-.382-.062-.76-.125-1.127-.2l.121.023,2.952,2.952c-.343-.062-.678-.133-1-.207L94.89,48.957c.031.008.062.012.094.019-.4-.09-.78-.179-1.142-.277a.651.651,0,0,0,.07.019l2.955,2.952c-.4-.105-.78-.214-1.119-.328l-2.955-2.959H92.8a9.744,9.744,0,0,1-1.31-.519c.027.012.058.027.09.043l2.963,2.963c-.257-.125-.511-.257-.764-.386l-2.226-2.238c-.055.09-.113.168-.172.253q-1.468-1.468-2.932-2.932c.027-.043.055-.09.082-.136a8.214,8.214,0,0,1-.678.908c.1-.113.195-.226.285-.343l2.932,2.932c-.113.152-.234.3-.359.437L87.778,46.43s.02-.023.031-.035c-.183.207-.378.4-.581.589.062-.058.129-.113.187-.175l2.94,2.936c-.133.133-.269.261-.413.382L87,47.187c.027-.023.051-.047.078-.07q-.287.251-.6.48c.035-.027.074-.051.109-.078l2.94,2.94c-.148.117-.3.226-.464.331l-2.94-2.94c.051-.031.094-.07.144-.1-.211.148-.433.289-.659.421l.062-.035,2.94,2.94c-.168.1-.339.191-.511.281l-2.94-2.936c.094-.047.179-.1.269-.148-.253.136-.511.269-.78.386h.008L87.6,51.6c-.183.078-.37.16-.561.23L84.1,48.887c.156-.058.312-.121.46-.187a11.166,11.166,0,0,1-1.216.433c.066-.019.136-.035.2-.058l2.944,2.944c-.2.066-.409.121-.62.175l-2.944-2.944c.113-.031.226-.062.339-.1q-.6.17-1.24.292c.1-.019.207-.035.3-.055l2.944,2.944c-.218.047-.444.086-.671.125l-2.944-2.944c.074-.012.14-.027.214-.039-.417.074-.85.129-1.3.172.144-.012.292-.027.437-.043l2.944,2.944c-.234.027-.476.051-.721.07l-2.944-2.944c.039,0,.078-.008.121-.012-.491.039-1,.062-1.525.062q.357,0,.7-.012l2.948,2.944c-.261.012-.519.019-.78.016l-2.948-2.952h.078c-.4,0-.78-.016-1.154-.035.082,0,.16.012.242.016a.5.5,0,0,1,.078,0L81,52.653c-.289-.012-.565-.027-.842-.051l-2.948-2.948.207.012c-.374-.027-.741-.058-1.092-.109a.3.3,0,0,1,.058.008l2.952,2.948c-.324-.043-.639-.094-.944-.152l-2.955-2.952q.409.082.819.14c-.02,0-.055-.008,0,0a.3.3,0,0,1,.058.008,13.711,13.711,0,0,1-2.125-.456l.066.023c.07.023.14.039.211.062l2.955,2.955a11.333,11.333,0,0,1-1.181-.39l-2.963-2.963c.117.047.242.082.363.125a9.554,9.554,0,0,1-2.16-1.076c.039.027.078.058.117.086.07.047.136.09.207.133l2.979,2.979a11.874,11.874,0,0,1-2.238-1.907c-.745-.753-1.493-1.5-2.238-2.25.055.055.113.1.172.152a8.055,8.055,0,0,1-2-3.041l-2.421-2.421v.741l2.932,2.932v.792L66.053,43.1v.737l2.932,2.932v.8l-2.932-2.932v.737L68.985,48.3v.8l-2.932-2.932v2.273l2.932,2.932v.589h-.207L65.831,49h-.737l2.948,2.952H67.25L64.3,49h-.737l2.948,2.952h-.791L62.774,49h-.737l2.948,2.952h-.8L61.241,49H60.5l2.948,2.952h-.8L59.709,49h-.741l2.948,2.952h-.8L58.173,49h-.737l2.948,2.952h-.14L57.311,49V46.61l-2.328-2.328h-.737l2.948,2.948h-.8l-2.948-2.948h-.737l2.948,2.948H55.4v.538q-1.468-1.462-2.932-2.932V47.1q1.462,1.468,2.932,2.932v.8L52.473,47.9v.737L55.4,51.569v.386H55Q53.521,50.481,52.048,49h-.737q1.474,1.48,2.948,2.952h-.791L50.519,49h-.737l2.948,2.952h-.8L48.987,49H48.25L51.2,51.955h-.8L47.455,49h-.737l2.948,2.952h-.8L45.922,49h-.737l2.948,2.952h-.8L44.39,49h-.655V42.219L41.3,39.786v-.8l2.433,2.433v-.737L41.3,38.254v2.269l2.433,2.433v.8L41.3,41.319v2.273l2.433,2.433v.8L41.3,44.387v.737l2.433,2.433v.8L41.3,45.92v2.269l2.932,2.928v.8L41.3,48.98V49h-.717l2.948,2.948h-.8L39.789,49h-.737L42,51.951h-.8L38.257,49H37.52l2.948,2.948h-.792L36.728,49h-.737l2.948,2.948h-.792L35.2,49h-.741l2.948,2.948h-.8L33.664,49h-.737l2.948,2.948h-.382L32.56,49V41.771l-.522-.522H31.3l1.259,1.259v.8l-2.055-2.055h-.741l2.792,2.792V44.2h-.639l-2.948-2.948h-.737L31.18,44.2h-.8l-2.948-2.948h-.632v3.174l2.932,2.932v.791l-2.932-2.932v.737l2.932,2.932v.8l-2.932-2.932v.737l2.932,2.932v.792l-2.932-2.928V49h-.012l2.944,2.944h0l-.791,0L26,49h-.741l2.948,2.948h-.8L24.462,49h-.737l2.948,2.948h-.8L22.93,49h-.737l2.948,2.948h-.791L21.4,49h-.737l2.948,2.948h-.8L19.869,49h-.737l2.948,2.948h-.8L18.337,49h-.273l.008-23.511ZM29.683,29v.792l-2.932-2.932v-.8L29.683,29Zm84,11.966v.8L112.33,40.41a4.66,4.66,0,0,0-.156-.951Zm44.889-1.088c-.078.183-.168.363-.257.534q-1.468-1.468-2.936-2.932c.094-.175.179-.355.261-.538l2.932,2.932Zm-26.24,6.741v-.8l2.117,2.117v.792l-2.117-2.117Zm1.661-9.853v.784l-2.932-2.928v-.8L133.229,36h0Zm0,4.585v.8l-2.932-2.928v-.8q1.462,1.468,2.932,2.932ZM43.677,45.319,41.244,42.89v-.8l2.433,2.433Z",
    transform: "translate(-3.575 -3.6)",
    fill: "#093266"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M221.507,102.758l.183-.558c-.678-.675-1.353-1.353-2.031-2.027.07-.2.133-.4.191-.6l2.035,2.035.179-.558-2.07-2.07c.019-.1.035-.2.055-.3a10.151,10.151,0,0,1-.729,2.32c.047-.1.094-.195.136-.3.682.686,1.369,1.369,2.055,2.055Z",
    transform: "translate(-133.807 -60.205)",
    fill: "#093266"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M381.251,94.69c-.16.1-.324.2-.491.285a2.047,2.047,0,0,0,1.314.788l-.975-.975.152-.094Z",
    transform: "translate(-232.301 -57.77)",
    fill: "#093266"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M220.245,107.656l.183-.558q-1.053-1.053-2.105-2.109c.027-.058.055-.121.082-.179a8.331,8.331,0,0,1-.534.971c.066-.1.133-.207.191-.308Z",
    transform: "translate(-132.922 -63.944)",
    fill: "#093266"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M313.54,95.56l.671.667h.737l-.671-.667Z",
    transform: "translate(-191.29 -58.301)",
    fill: "#093266"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M126.9,74.534a2.235,2.235,0,0,0-.538.2l2.936,2.936a1.7,1.7,0,0,0-.444.351q-1.468-1.462-2.932-2.928a1.887,1.887,0,0,0-.289.448l2.928,2.928a2.7,2.7,0,0,0-.2.593Q126.9,77.6,125.44,76.132a4.956,4.956,0,0,0-.09.651q1.187,1.187,2.371,2.367h2.441V77.423a3.027,3.027,0,0,0-.32.051Q128.374,76,126.9,74.53Z",
    transform: "translate(-76.476 -45.471)",
    fill: "#093266"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M133.617,76.044,131.975,74.4a3.927,3.927,0,0,0-.706-.062h-.09l2.53,2.53a5.111,5.111,0,0,0-.09-.83Z",
    transform: "translate(-80.033 -45.355)",
    fill: "#093266"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M137.69,81.545v0Z",
    transform: "translate(-84.004 -49.589)",
    fill: "#093266"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M366.04,76.891a1.836,1.836,0,0,0-.039-.367l-.951-.951a2.1,2.1,0,0,0-.437-.043h-.343l1.723,1.727a1.742,1.742,0,0,0,.047-.367Z",
    transform: "translate(-222.241 -46.081)",
    fill: "#093266"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M317.47,95.56c.222.222.444.444.671.667h.737l-.671-.667Z",
    transform: "translate(-193.688 -58.301)",
    fill: "#093266"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M358.09,79.987l.534.534h.737L358.09,79.25Z",
    transform: "translate(-218.47 -48.35)",
    fill: "#093266"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M125.28,81.214v.328c0-.156.008-.316.008-.472C125.288,81.121,125.28,81.16,125.28,81.214Z",
    transform: "translate(-76.433 -49.461)",
    fill: "#093266"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M358.172,75.53h-.082v.659l2.063,2.063h.686a.406.406,0,0,1,.043,0l-2.714-2.718Z",
    transform: "translate(-218.47 -46.081)",
    fill: "#093266"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M363.346,77.8l-2.269-2.269h-.737l2.585,2.585a1.166,1.166,0,0,0,.425-.316Z",
    transform: "translate(-219.843 -46.081)",
    fill: "#093266"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M325.966,95.4h-.636l.671.667h.737l-.772-.772Z",
    transform: "translate(-198.483 -58.136)",
    fill: "#093266"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M304,76.747h.487L304,76.26Z",
    transform: "translate(-185.47 -46.526)",
    fill: "#093266"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M305.31,75.53l.772.772h.737l-.772-.772Z",
    transform: "translate(-186.269 -46.081)",
    fill: "#093266"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M321.4,95.56l.671.667h.737l-.667-.667Z",
    transform: "translate(-196.086 -58.301)",
    fill: "#093266"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M317.1,75.53c.257.257.515.519.772.772h.737l-.772-.772Z",
    transform: "translate(-193.462 -46.081)",
    fill: "#093266"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M309.24,75.53l.772.772h.741l-.776-.772Z",
    transform: "translate(-188.667 -46.081)",
    fill: "#093266"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M321.03,75.53l.772.772h.741l-.776-.772Z",
    transform: "translate(-195.86 -46.081)",
    fill: "#093266"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M313.17,75.53l.772.772h.741l-.772-.772Z",
    transform: "translate(-191.065 -46.081)",
    fill: "#093266"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M331.511,72.331,328.86,69.68v.737l2.651,2.651Z",
    transform: "translate(-200.637 -42.512)",
    fill: "#093266"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M252.4,96.572l-.082-.082a3.007,3.007,0,0,0-.725-.292l-.386-.078.639.639a1.96,1.96,0,0,0,.554-.183Z",
    transform: "translate(-153.263 -58.643)",
    fill: "#093266"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M223.48,98.659l.183-.558q-1.123-1.117-2.238-2.242c0-.035,0-.07.008-.109-.027.3-.066.589-.113.869a.906.906,0,0,0,.019-.109l2.141,2.141Z",
    transform: "translate(-135.027 -58.417)",
    fill: "#093266"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M242.5,95.341c.281.035.554.062.827.086l-1.263-1.263,1,.207,1.107,1.107c.187.008.378.016.558.016.07,0,.121-.008.187-.008l-.92-.92-2.581-.534c-.136-.039-.261-.082-.394-.121a.412.412,0,0,0,.074.023l1.408,1.408Z",
    transform: "translate(-147.046 -57.294)",
    fill: "#093266"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M237.58,93.549l-1.673-1.673a11.508,11.508,0,0,1-1.408-.667l2.144,2.144C236.952,93.429,237.264,93.495,237.58,93.549Z",
    transform: "translate(-143.068 -55.647)",
    fill: "#093266"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M224.08,81l-.148.456,1.142-3.509.916.577a8.906,8.906,0,0,0,2.312.963c-1.131-1.006-2.164-2.148-3.228-3.224.109.109.234.2.351.3a6.075,6.075,0,0,1-.932-1.025c.059.082.1.172.164.25v.444q-1.468-1.468-2.932-2.932v-.792q1.14,1.135,2.273,2.273a.07.07,0,0,0,.02.027,6.637,6.637,0,0,1-.546-1.474c.019.074.027.156.051.23-.6-.6-1.2-1.2-1.794-1.8v-.792c.526.522,1.049,1.049,1.575,1.575.02.125.055.234.078.355a9.459,9.459,0,0,1-.172-1.677c0,.164,0,.331.008.5l-1.489-1.489v-.792l1.474,1.474v.043a8.619,8.619,0,0,1,.058-.916c-.008.058-.016.113-.023.172l-1.509-1.509v8.4l2.737,2.737-.195.6Q223,79.171,221.729,77.9v.055c0,.339-.019.667-.039.99.008-.109.02-.214.023-.324Q222.9,79.812,224.092,81Zm-2.359-6.956q1.468,1.462,2.932,2.932v.791l-1.006-1c-.643-.639-1.283-1.287-1.926-1.926v-.791Zm.792,3.115-.792-.791V75.58q1.468,1.462,2.932,2.932v.741l-.012.039-2.125-2.129Z",
    transform: "translate(-135.253 -41.92)",
    fill: "#093266"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M190.606,118.335c.027,0-.148-.008,0,0Z",
    transform: "translate(-116.252 -72.194)",
    fill: "#093266"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M263.029,75.752a9.372,9.372,0,0,0-1.139-.4l1.692,1.692c-.039-.016-.082-.027-.117-.043a14.525,14.525,0,0,1,1.474.647c-.012,0-.02-.012-.031-.016l-1.879-1.875Z",
    transform: "translate(-159.779 -45.971)",
    fill: "#093266"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M272.444,82.88c.07.051.14.1.207.148-.02-.016-.039-.035-.062-.051-.047-.035-.1-.062-.148-.1Z",
    transform: "translate(-166.215 -50.565)",
    fill: "#093266"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M253.267,74.459c-.285-.051-.565-.105-.873-.133l1.3,1.3-1.025-.23-1.107-1.107c-.23-.008-.441-.031-.686-.031-.031,0-.051,0-.082,0l.924.924-1.025-.23-.616-.616a1.941,1.941,0,0,0-.554.187l.168.168a1.927,1.927,0,0,1-.261-.113,3.833,3.833,0,0,0,.628.234l3.794.854c.339.1.659.2.975.3-.027-.008-.051-.02-.078-.027l-1.486-1.482Z",
    transform: "translate(-152.177 -45.306)",
    fill: "#093266"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M162.194,93.569c-.074-.3-.144-.608-.195-.932l-1.879-1.879v-.8l1.77,1.77c-.023-.253-.035-.519-.047-.784l-1.723-1.727v2.273Z",
    transform: "translate(-97.689 -54.287)",
    fill: "#093266"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M59.43,76.127l.035.039h.741l-.776-.776Z",
    transform: "translate(-36.258 -45.995)",
    fill: "#093266"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M99.049,71.077v-.4c0-.214.012-.417.023-.624,0,.1-.008.195-.012.292L96.62,67.9v-.791l2.472,2.472v.09q.035-.474.094-.924c-.008.055-.02.109-.023.164l-2.538-2.538v-.8l2.64,2.636c.039-.226.09-.444.14-.659,0,.016-.008.031-.012.051l-2.764-2.764v3.8l2.433,2.433Z",
    transform: "translate(-58.948 -39.339)",
    fill: "#093266"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M99.043,80.37v-.741L96.61,77.2v.737Z",
    transform: "translate(-58.942 -47.1)",
    fill: "#093266"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M99.043,85.838V85.1L96.61,82.668v-.792l2.433,2.433v-.737L96.61,81.14v2.269l2.433,2.433Z",
    transform: "translate(-58.942 -49.503)",
    fill: "#093266"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M137.684,104.43h0l0,0Z",
    transform: "translate(-83.998 -63.713)",
    fill: "#093266"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M125.28,86.28h.07l-.07-.07Z",
    transform: "translate(-76.433 -52.597)",
    fill: "#093266"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M135.28,105.229l-.8-.8h-.741l1.54,1.536Z",
    transform: "translate(-81.595 -63.713)",
    fill: "#093266"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M59.43,72.2,61,73.768h.741L59.43,71.46Z",
    transform: "translate(-36.258 -43.598)",
    fill: "#093266"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M187.73,95.79a1.529,1.529,0,0,0,.908.811A1.579,1.579,0,0,1,187.73,95.79Z",
    transform: "translate(-114.534 -58.441)",
    fill: "#093266"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M187.221,93.867l.994.994a3.155,3.155,0,0,0,.885.148l-2.09-2.09A3.415,3.415,0,0,0,187.221,93.867Z",
    transform: "translate(-114.095 -56.69)",
    fill: "#093266"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M186.92,90.946c0,.058.008.1.008.16,0-.105-.008-.211-.008-.316Z",
    transform: "translate(-114.04 -55.391)",
    fill: "#093266"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M192.765,98.27c.168,0,.328-.008.48-.02a6.122,6.122,0,0,1-.655.012c.058,0,.113.008.175.008Z",
    transform: "translate(-117.499 -59.942)",
    fill: "#093266"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M161.763,80.145v-.737l-1.743-1.743V77.63c.023.316.039.639.039.971v-.164l1.708,1.708Z",
    transform: "translate(-97.628 -47.362)",
    fill: "#093266"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M159.412,73.773l1.844,1.844V74.88l-2.024-2.02c-.012-.047-.031-.094-.043-.14a11.725,11.725,0,0,1,.292,1.669c-.012-.117-.02-.234-.035-.351-.012-.09-.023-.175-.039-.261Z",
    transform: "translate(-97.122 -44.366)",
    fill: "#093266"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M125.28,83.017l.866.866h.737l-1.6-1.6Z",
    transform: "translate(-76.433 -50.199)",
    fill: "#093266"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M223.369,66.381c-.008.043-.012.09-.016.133a7.653,7.653,0,0,1,.152-.768.055.055,0,0,1-.008.023l-1.727-1.727v.733l1.6,1.6Z",
    transform: "translate(-135.302 -38.784)",
    fill: "#093266"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M161.83,84.952l-1.7-1.7v-.8c.565.569,1.135,1.135,1.7,1.7v-.737l-1.7-1.7v2.269l1.7,1.7Z",
    transform: "translate(-97.695 -49.845)",
    fill: "#093266"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M198.454,175.64q-12.282-.988-24.587-.99t-24.587.99l24.607,2.971Z",
    transform: "translate(-91.075 -106.554)",
    fill: "#093266"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M2.308,44.332l-.023,18,17.631,2.129q-2.322.474-4.632.983c.23.277.452.561.678.838L0,64.357.023,45.084.07,10.473l1-.125L82.807,0l.144.016L165.092,10.4l.472.058V64.345l-15.9,1.922c.211-.273.413-.554.624-.827q-2.322-.509-4.648-.986l17.643-2.133V12.477L82.807,2.3,2.351,12.485,2.332,26.63Z",
    fill: "#00aeef"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M157.3,180.165,132.7,177.194c-3.536.285-7.069.612-10.6,1.018l35.068,4.234.136.016,35.157-4.254c-3.525-.405-7.057-.733-10.59-1.018L157.3,180.161Z",
    transform: "translate(-74.493 -108.103)",
    fill: "#00aeef"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M59.44,58.435l2.928,2.928,0-.792L59.44,57.64Z",
    transform: "translate(-36.264 -35.166)",
    fill: "#020000"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M62.362,65.294V64.5L59.434,61.57v.359l0,.437Z",
    transform: "translate(-36.258 -37.564)",
    fill: "#020000"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M62.362,69.221v-.8L59.43,65.49v.8Z",
    transform: "translate(-36.258 -39.955)",
    fill: "#020000"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M61.738,72.53h.624v-.172L59.43,69.43v.791Z",
    transform: "translate(-36.258 -42.359)",
    fill: "#020000"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M59.43,74.151l.776.776H61L59.43,73.36Z",
    transform: "translate(-36.258 -44.757)",
    fill: "#020000"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M59.43,77.319h.035l-.035-.039Z",
    transform: "translate(-36.258 -47.148)",
    fill: "#020000"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M73.352,97.172V96.65H72.83Z",
    transform: "translate(-44.433 -58.966)",
    fill: "#020000"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M70.955,98.7v-.791L69.7,96.65h-.8Z",
    transform: "translate(-42.036 -58.966)",
    fill: "#020000"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M67.918,99.6h.639v-.156l-2.792-2.8h-.8Z",
    transform: "translate(-39.638 -58.966)",
    fill: "#020000"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M63.988,99.6h.8L61.835,96.65h-.8Z",
    transform: "translate(-37.24 -58.966)",
    fill: "#020000"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M59.42,97.732l2.932,2.932v-.8L59.42,96.94Z",
    transform: "translate(-36.252 -59.143)",
    fill: "#020000"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M59.42,101.655l2.932,2.932v-.8L59.42,100.86Z",
    transform: "translate(-36.252 -61.535)",
    fill: "#020000"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M62.352,108.517v-.8L59.42,104.79v.8Z",
    transform: "translate(-36.252 -63.932)",
    fill: "#020000"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M62.352,112.447v-.8L59.42,108.72v.8Z",
    transform: "translate(-36.252 -66.33)",
    fill: "#020000"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M62.352,116.374v-.792L59.42,112.65v.8Z",
    transform: "translate(-36.252 -68.728)",
    fill: "#020000"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M60.3,119.5h.791v0l-2.944-2.944h-.8Z",
    transform: "translate(-34.989 -71.107)",
    fill: "#020000"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M56.368,119.5h.8l-2.952-2.948H53.42Z",
    transform: "translate(-32.591 -71.107)",
    fill: "#020000"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M52.438,119.5h.8l-2.952-2.948H49.49Z",
    transform: "translate(-30.194 -71.107)",
    fill: "#020000"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M48.508,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-27.796 -71.107)",
    fill: "#020000"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M44.578,119.5h.8l-2.952-2.948H41.63Z",
    transform: "translate(-25.398 -71.107)",
    fill: "#020000"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M40.648,119.5h.792l-2.948-2.948H37.7Z",
    transform: "translate(-23.001 -71.107)",
    fill: "#020000"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M189.862,59.654V59.2L186.93,56.25v.472Z",
    transform: "translate(-114.046 -34.318)",
    fill: "#020000"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M189.862,63.08v-.792L186.93,59.36v.792Z",
    transform: "translate(-114.046 -36.215)",
    fill: "#020000"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M186.93,64.075,189.862,67v-.792L186.93,63.28v.8Z",
    transform: "translate(-114.046 -38.607)",
    fill: "#020000"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M189.862,70.937v-.8L186.93,67.21v.8Z",
    transform: "translate(-114.046 -41.005)",
    fill: "#020000"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M189.862,74.864v-.792L186.93,71.14v.8Z",
    transform: "translate(-114.046 -43.402)",
    fill: "#020000"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M189.862,78.794V78L186.93,75.07v.791Z",
    transform: "translate(-114.046 -45.8)",
    fill: "#020000"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M189.858,82.724v-.792L186.93,79v.792Z",
    transform: "translate(-114.046 -48.198)",
    fill: "#020000"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M189.852,86.654v-.792L186.92,82.93v.8q1.462,1.468,2.932,2.932Z",
    transform: "translate(-114.04 -50.595)",
    fill: "#020000"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M189.852,90.584v-.8q-1.468-1.462-2.932-2.928v.791Z",
    transform: "translate(-114.04 -52.993)",
    fill: "#020000"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M186.934,91.1c0,.179.012.351.027.511l2.09,2.09h.086q.328.006.655-.012h.043l-2.9-2.909h0c0,.109.008.214.008.32Z",
    transform: "translate(-114.046 -55.385)",
    fill: "#020000"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M187.62,95.509a1.59,1.59,0,0,0,.908.811l.016,0-.994-.994c.023.058.043.121.07.175Z",
    transform: "translate(-114.424 -58.161)",
    fill: "#020000"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M254.161,97.14c-.023-.019-.058-.043-.1-.07h0l.082.082A.125.125,0,0,0,254.161,97.14Z",
    transform: "translate(-155.002 -59.222)",
    fill: "#020000"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M249.768,96.482c.129-.008.246-.023.351-.039.051-.008.105-.016.152-.027l-.639-.639-1-.207.92.92a2,2,0,0,0,.218-.012Z",
    transform: "translate(-151.689 -58.307)",
    fill: "#020000"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M243.684,94.554l1.263,1.263.144.012c.211.016.413.027.616.035h.082l-1.107-1.107-1-.207Z",
    transform: "translate(-148.669 -57.685)",
    fill: "#020000"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M239.906,94.612c.261.043.522.086.78.117a.16.16,0,0,1,.043,0l-1.408-1.408-.074-.023c-.331-.105-.655-.214-.963-.328-.051-.02-.113-.035-.164-.055l1.673,1.673c.039.008.078.016.117.02Z",
    transform: "translate(-145.277 -56.69)",
    fill: "#020000"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M233.592,91.324h0c.086.023.172.043.257.066s.175.043.265.062l-2.144-2.144c-.027-.016-.051-.035-.078-.051a8.455,8.455,0,0,1-.858-.577c-.117-.09-.222-.187-.328-.281s-.242-.191-.351-.3c1.068,1.072,2.1,2.219,3.228,3.224Z",
    transform: "translate(-140.542 -53.75)",
    fill: "#020000"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M367.227,76.587a1.388,1.388,0,0,0-.113-.331c-.008-.016-.016-.027-.023-.043a1.008,1.008,0,0,0-.222-.285.039.039,0,0,1-.016-.019,1.05,1.05,0,0,0-.242-.152,1.736,1.736,0,0,0-.285-.1c-.016,0-.031-.012-.047-.016l.951.951v0Z",
    transform: "translate(-223.467 -46.148)",
    fill: "#020000"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M364.535,77.776a1.1,1.1,0,0,0,.136-.222c0-.008.008-.016.012-.023a1.544,1.544,0,0,0,.082-.273l-1.723-1.727h-.791l2.269,2.269a.149.149,0,0,0,.019-.023Z",
    transform: "translate(-221.008 -46.081)",
    fill: "#020000"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M361.392,78.209l.078-.023a1.665,1.665,0,0,0,.211-.07L359.1,75.53h-.8l2.714,2.718a1.891,1.891,0,0,0,.378-.035Z",
    transform: "translate(-218.598 -46.081)",
    fill: "#020000"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M358.09,78.011l1.271,1.271h.8L358.09,77.22Z",
    transform: "translate(-218.47 -47.112)",
    fill: "#020000"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M358.09,81.674h.534l-.534-.534Z",
    transform: "translate(-218.47 -49.503)",
    fill: "#020000"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M387.1,63.453a7.608,7.608,0,0,1,.472.881c.016.031.035.062.051.094l2.92,2.92a10.333,10.333,0,0,0-2.378-3.072c-.667-.671-1.333-1.345-2-2.016.066.066.129.133.191.2.019.023.035.047.055.07a6.831,6.831,0,0,1,.651.842l.047.082Z",
    transform: "translate(-235.596 -37.985)",
    fill: "#020000"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M391.117,71.732l2.928,2.928a8.761,8.761,0,0,0-.207-1L390.91,70.73c.016.058.027.113.043.172-.012-.043,0,.008,0,.016.016.066.023.136.039.2.039.172.074.347.1.522,0,.027.012.058.016.086Z",
    transform: "translate(-238.494 -43.152)",
    fill: "#020000"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M391.683,76.2v.039l2.932,2.932q0-.409-.023-.819L391.66,75.42c0,.039,0,.078.008.117,0,.113,0,.23.008.343,0,.09.012.172.012.261a.3.3,0,0,1,0,.058Z",
    transform: "translate(-238.951 -46.014)",
    fill: "#020000"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M391.36,79.994l2.94,2.936c.043-.23.074-.46.1-.694L391.461,79.3c0,.055-.016.109-.023.168-.012.113-.031.222-.047.335-.012.062-.016.129-.027.191Z",
    transform: "translate(-238.768 -48.381)",
    fill: "#020000"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M331.511,59.537v-.62L328.86,56.25v.639Z",
    transform: "translate(-200.637 -34.318)",
    fill: "#020000"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M331.511,63.227v-.8L328.86,59.78v.8Z",
    transform: "translate(-200.637 -36.472)",
    fill: "#020000"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M331.511,67.157v-.8L328.86,63.71V64.5Z",
    transform: "translate(-200.637 -38.869)",
    fill: "#020000"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M331.511,71.087v-.8L328.86,67.64v.8Z",
    transform: "translate(-200.637 -41.267)",
    fill: "#020000"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M328.86,71.57v.8l2.651,2.647v-.792Z",
    transform: "translate(-200.637 -43.665)",
    fill: "#020000"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M326.86,75.506l2.948,2.948h.483v-.312L327.64,75.49V75.5h-.78Z",
    transform: "translate(-199.417 -46.056)",
    fill: "#020000"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M323.7,76.3h.8l-.776-.772h-.8Z",
    transform: "translate(-197.013 -46.081)",
    fill: "#020000"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M326.97,77.53v.8l2.928,2.928v-.78l-.768-.776h0Z",
    transform: "translate(-199.484 -47.301)",
    fill: "#020000"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M329.892,85.184v-.792L326.96,81.46v.792q1.468,1.468,2.932,2.928Z",
    transform: "translate(-199.478 -49.699)",
    fill: "#020000"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M318.99,75.53l.776.772h.792l-.772-.772Z",
    transform: "translate(-194.615 -46.081)",
    fill: "#020000"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M390.53,83.234Q392,84.7,393.462,86.17c.07-.2.133-.4.187-.6q-1.468-1.468-2.932-2.936c0,.02-.012.035-.016.051-.016.058-.035.117-.055.175C390.608,82.985,390.573,83.11,390.53,83.234Z",
    transform: "translate(-238.262 -50.412)",
    fill: "#020000"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M389.33,86.074c.979.975,1.957,1.957,2.936,2.932.094-.175.179-.351.257-.534q-1.468-1.462-2.932-2.932c-.082.183-.168.359-.261.538Z",
    transform: "translate(-237.53 -52.188)",
    fill: "#020000"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M387.83,88.6q1.468,1.468,2.936,2.94c.113-.156.218-.316.32-.476q-1.468-1.468-2.936-2.932c-.047.074-.1.144-.148.218-.012.016-.023.035-.035.051-.047.066-.09.136-.136.2Z",
    transform: "translate(-236.614 -53.768)",
    fill: "#020000"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M391.269,96.04l-.055-.472-2.031-2.043c.058-.066.113-.133.168-.2l-2.936-2.936q-.181.216-.374.421l1.918,1.918.324-.105.058.487,2.928,2.928Z",
    transform: "translate(-235.522 -55.147)",
    fill: "#020000"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M383.98,92.783l1.525,1.525s.035,0,.051-.008a3.406,3.406,0,0,0,.491-.113l.1-.031-1.735-1.735c-.074.066-.148.129-.226.191-.062.055-.129.109-.191.164,0,0-.008.008-.012.012Z",
    transform: "translate(-234.266 -56.385)",
    fill: "#020000"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M392.19,99.51l.105.9,2.928,2.928-.105-.9Z",
    transform: "translate(-239.275 -60.711)",
    fill: "#020000"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M392.815,104.867l2.924,2.928-.1-.9-2.928-2.928.066.577Z",
    transform: "translate(-239.592 -63.432)",
    fill: "#020000"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M382.074,94.177c-.094.062-.195.125-.292.183-.051.031-.1.066-.152.094l.975.975a2.253,2.253,0,0,0,.246.027c.148,0,.32-.008.487-.016a.335.335,0,0,0,.062,0l-1.283-1.287Z",
    transform: "translate(-232.832 -57.441)",
    fill: "#020000"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M396.263,112.249l-.105-.9-2.928-2.928.105.9Z",
    transform: "translate(-239.909 -66.147)",
    fill: "#020000"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M393.42,113.537l2.94,2.94.187-.09-.07-.585-2.928-2.932.066.565Z",
    transform: "translate(-240.025 -68.862)",
    fill: "#020000"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M393.654,118.384c.191-.074.378-.152.558-.234l-2.944-2.94c-.051.023-.109.043-.16.066-.133.058-.261.117-.4.168l2.944,2.944Z",
    transform: "translate(-238.372 -70.289)",
    fill: "#020000"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M387.68,116.432l2.944,2.944c.214-.051.421-.105.628-.168l-2.944-2.948-.031.008c-.074.023-.152.039-.226.062-.121.035-.242.07-.37.1Z",
    transform: "translate(-236.523 -70.93)",
    fill: "#020000"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M384.29,117.106l2.948,2.948c.238-.023.472-.051.706-.09L385,117.02c-.133.023-.265.035-.4.051-.082.012-.164.023-.246.031a.342.342,0,0,0-.062.008Z",
    transform: "translate(-234.455 -71.394)",
    fill: "#020000"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M383.385,120.265c.269.016.534.016.8.008l-2.948-2.948c-.094,0-.183.008-.277.008-.183,0-.359-.012-.534-.023l2.952,2.952Z",
    transform: "translate(-232.1 -71.571)",
    fill: "#020000"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M376.54,116.666a8.334,8.334,0,0,1-.92-.226l2.959,2.955a7.891,7.891,0,0,0,1.037.242l-2.948-2.948a.409.409,0,0,1-.066-.016.351.351,0,0,1-.062-.012Z",
    transform: "translate(-229.165 -71.04)",
    fill: "#020000"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M358.084,102.7l1.63,1.634-.6-.636c-.351-.374-.69-.733-1.033-1.084v.086Z",
    transform: "translate(-218.464 -62.602)",
    fill: "#020000"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M367,111.353c-.1-.062-.195-.129-.289-.195-.253-.179-.5-.363-.741-.561-.066-.055-.133-.109-.2-.168-.156-.133-.312-.265-.464-.405h0l-.195-.183c.745.745,1.489,1.493,2.238,2.234a13.66,13.66,0,0,0,3.614,2.819l-2.971-2.971a.243.243,0,0,1-.047-.023c-.008,0-.012-.008-.02-.012-.062-.031-.121-.07-.187-.105-.253-.136-.5-.281-.737-.437Z",
    transform: "translate(-222.753 -67.013)",
    fill: "#020000"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M361.018,108.454v-.8l-2.928-2.928v.791Z",
    transform: "translate(-218.47 -63.896)",
    fill: "#020000"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M358.09,109.445l2.928,2.932v-.8l-2.928-2.932v.8Z",
    transform: "translate(-218.47 -66.287)",
    fill: "#020000"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M361.012,116.307v-.8l-2.928-2.932,0,.472v.324Z",
    transform: "translate(-218.464 -68.685)",
    fill: "#020000"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M326.96,86.185q1.462,1.468,2.932,2.932v-.8q-1.468-1.468-2.932-2.932v.792Z",
    transform: "translate(-199.478 -52.096)",
    fill: "#020000"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M356.08,116.526l2.948,2.948h.764v-.031l-2.932-2.932v.016Z",
    transform: "translate(-217.244 -71.083)",
    fill: "#020000"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M326.96,90.109l2.932,2.928v-.8L326.96,89.31v.8Z",
    transform: "translate(-199.478 -54.488)",
    fill: "#020000"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M355.1,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-214.846 -71.107)",
    fill: "#020000"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M327.732,94.817h.5v.5l2.113,2.117v-.487l-.456-.46v-.3L326.96,93.25v.8Z",
    transform: "translate(-199.478 -56.892)",
    fill: "#020000"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M351.168,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-212.448 -71.107)",
    fill: "#020000"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M323.3,95.56l.667.667h.8l-.671-.667Z",
    transform: "translate(-197.245 -58.301)",
    fill: "#020000"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M332.337,103.359v-.8l-2.113-2.113v.316l0,.476Z",
    transform: "translate(-201.467 -61.284)",
    fill: "#020000"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M347.238,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-210.051 -71.107)",
    fill: "#020000"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M319.36,95.56l.671.667h.8l-.671-.667Z",
    transform: "translate(-194.841 -58.301)",
    fill: "#020000"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M343.308,119.5h.8l-2.952-2.948h-.792Z",
    transform: "translate(-207.653 -71.107)",
    fill: "#020000"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M332.337,107.289v-.8l-2.117-2.113v.791Z",
    transform: "translate(-201.467 -63.682)",
    fill: "#020000"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M330.22,108.3v.8l2.117,2.117v-.792Z",
    transform: "translate(-201.467 -66.074)",
    fill: "#020000"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M315.43,95.56l.671.667h.8c-.222-.222-.444-.444-.671-.667h-.792Z",
    transform: "translate(-192.443 -58.301)",
    fill: "#020000"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M339.378,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-205.255 -71.107)",
    fill: "#020000"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M333.152,115.957v-.791l-2.932-2.936v.8Z",
    transform: "translate(-201.467 -68.471)",
    fill: "#020000"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M328.57,116.312l2.948,2.948h.628V119.1l-2.932-2.936v.152Z",
    transform: "translate(-200.46 -70.869)",
    fill: "#020000"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M327.588,119.5h.792l-2.948-2.948h-.792Z",
    transform: "translate(-198.062 -71.107)",
    fill: "#020000"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M323.658,119.5h.792L321.5,116.55h-.792Z",
    transform: "translate(-195.665 -71.107)",
    fill: "#020000"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M319.728,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-193.267 -71.107)",
    fill: "#020000"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M315.792,119.5h.792l-2.948-2.948h-.8l2.948,2.948Z",
    transform: "translate(-190.863 -71.107)",
    fill: "#020000"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M311.862,119.5h.792l-2.948-2.948h-.8l2.948,2.948Z",
    transform: "translate(-188.465 -71.107)",
    fill: "#020000"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M315.07,75.53l.772.772h.8l-.772-.772h-.792Z",
    transform: "translate(-192.224 -46.081)",
    fill: "#020000"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M311.13,75.53l.776.772h.792l-.772-.772Z",
    transform: "translate(-189.82 -46.081)",
    fill: "#020000"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M307.2,75.53l.772.772h.8L308,75.53Z",
    transform: "translate(-187.422 -46.081)",
    fill: "#020000"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M304,75.53v.285l.487.487h.8l-.772-.772Z",
    transform: "translate(-185.47 -46.081)",
    fill: "#020000"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M278.7,62.32v-.355l-2.273-2.285-.094.269Z",
    transform: "translate(-168.588 -36.411)",
    fill: "#020000"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M278.062,65.127v-.792L275.5,61.77l-.211.585Z",
    transform: "translate(-167.954 -37.686)",
    fill: "#020000"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M277.186,68.181l.211-.585-2.936-2.936-.211.585Z",
    transform: "translate(-167.319 -39.449)",
    fill: "#020000"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M276.146,71.077l.211-.585-2.936-2.932-.211.585Z",
    transform: "translate(-166.685 -41.218)",
    fill: "#020000"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M275.106,73.971l.211-.585-2.936-2.936-.211.585Z",
    transform: "translate(-166.051 -42.981)",
    fill: "#020000"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M271.14,73.925l2.936,2.936.207-.585-2.932-2.936-.148.413Z",
    transform: "translate(-165.422 -44.745)",
    fill: "#020000"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M270.1,76.825l2.936,2.936.211-.585-2.936-2.936-.062.172Z",
    transform: "translate(-164.788 -46.514)",
    fill: "#020000"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M266.7,78.268a.216.216,0,0,0,.031.016c.179.094.355.187.522.289l.175.105c.129.082.253.164.37.25.047.035.1.062.148.1.023.016.039.035.062.051a5.687,5.687,0,0,1,1.447,1.583c.031.051.058.105.09.16a5.227,5.227,0,0,1,.234.468c.02.039.043.078.059.117.612.612,1.228,1.228,1.84,1.844v-.573c-.862-.912-1.77-1.786-2.659-2.675l.5.3-2.971-2.971c-.269-.16-.534-.32-.8-.468a9.107,9.107,0,0,0-.916-.456l1.879,1.875Z",
    transform: "translate(-161.572 -46.612)",
    fill: "#020000"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M260.292,75c-.058-.016-.113-.039-.175-.055-.156-.043-.316-.074-.476-.109-.121-.023-.246-.039-.37-.062l1.486,1.482c.027.008.051.02.078.027.363.117.706.242,1.033.367.039.016.082.027.117.043Z",
    transform: "translate(-158.18 -45.617)",
    fill: "#020000"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M257.043,75.671l-1.3-1.3c-.261-.023-.55-.027-.83-.039l1.107,1.107,1.025.23Z",
    transform: "translate(-155.52 -45.349)",
    fill: "#020000"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M252.731,75.184l-.924-.924a3.555,3.555,0,0,0-.429.027c-.047,0-.09.012-.133.019a1.573,1.573,0,0,0-.156.031l.616.616Z",
    transform: "translate(-153.19 -45.306)",
    fill: "#020000"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M249.534,74.93c-.031.02-.074.039-.094.055.055.027.14.066.261.113Z",
    transform: "translate(-152.183 -45.715)",
    fill: "#020000"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M311.5,95.56l.671.667h.8l-.671-.667Z",
    transform: "translate(-190.046 -58.301)",
    fill: "#020000"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M307.57,95.56l.671.667h.792l-.667-.667Z",
    transform: "translate(-187.648 -58.301)",
    fill: "#020000"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M304,95.56V95.7l.53.53h.8l-.671-.667Z",
    transform: "translate(-185.47 -58.301)",
    fill: "#020000"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M307.928,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-186.068 -71.107)",
    fill: "#020000"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M304,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-183.67 -71.107)",
    fill: "#020000"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M280.029,94.274v-.8L278.52,91.97a4.616,4.616,0,0,1,.156.951Z",
    transform: "translate(-169.925 -56.111)",
    fill: "#020000"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M300.068,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-181.272 -71.107)",
    fill: "#020000"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M279.06,97.052v.183l1.3,1.3v-.8l-1.3-1.3v.214c0,.074.008.144.008.222,0,.058-.008.113-.008.172Z",
    transform: "translate(-170.254 -58.838)",
    fill: "#020000"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M296.138,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-178.875 -71.107)",
    fill: "#020000"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M278.71,100.972l1.435,1.435v-.8L278.8,100.27c-.012.125-.031.246-.047.367a.2.2,0,0,1-.008.047C278.737,100.777,278.726,100.878,278.71,100.972Z",
    transform: "translate(-170.041 -61.175)",
    fill: "#020000"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M277.92,104.252,279.663,106v-.8l-1.56-1.56c-.019.082-.047.16-.07.238-.027.1-.055.191-.086.289A.725.725,0,0,1,277.92,104.252Z",
    transform: "translate(-169.559 -63.231)",
    fill: "#020000"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M292.208,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-176.477 -71.107)",
    fill: "#020000"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M288.278,119.5h.8l-2.948-2.948h-.8Z",
    transform: "translate(-174.079 -71.107)",
    fill: "#020000"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M276.724,107.114l2.207,2.2v-.791l-1.946-1.946s-.008.012-.012.02c-.027.062-.062.121-.09.183-.055.109-.105.222-.164.331Z",
    transform: "translate(-168.826 -65.024)",
    fill: "#020000"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M277.979,111.608,275.5,109.12a5.545,5.545,0,0,1-.335.46l2.932,2.932c.055-.07.117-.14.172-.214l2.647,2.663h.425l-2.948-2.948h-.409Z",
    transform: "translate(-167.875 -66.574)",
    fill: "#020000"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M273.23,111.706l2.936,2.94c.14-.125.277-.257.405-.39l-2.936-2.936c-.039.039-.078.074-.117.113-.062.062-.129.125-.195.187-.031.027-.062.058-.094.09Z",
    transform: "translate(-166.697 -67.916)",
    fill: "#020000"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M270.97,113.474l2.94,2.94c.164-.105.32-.211.468-.328l-2.936-2.936-.019.012c-.039.031-.086.058-.125.086-.109.074-.214.152-.328.222Z",
    transform: "translate(-165.318 -69.033)",
    fill: "#020000"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M268.42,114.945l2.94,2.94c.183-.086.359-.172.53-.265l-2.94-2.94-.214.105a.21.21,0,0,1-.043.02c-.09.047-.179.094-.273.136Z",
    transform: "translate(-163.763 -69.966)",
    fill: "#020000"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M265.574,116.133l2.94,2.944c.2-.066.394-.136.585-.207l-2.94-2.94c-.121.047-.25.086-.374.129-.062.023-.129.047-.191.066a.055.055,0,0,0-.023.008Z",
    transform: "translate(-162.024 -70.729)",
    fill: "#020000"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M262.474,117.042l2.944,2.948c.218-.051.433-.1.636-.156l-2.944-2.944c-.055.016-.113.027-.168.043l-.331.082-.14.035Z",
    transform: "translate(-160.133 -71.314)",
    fill: "#020000"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M259.14,117.709l2.948,2.948c.234-.031.46-.066.686-.109L259.83,117.6s-.039,0-.055.008c-.086.016-.172.027-.261.043-.121.02-.242.043-.37.058Z",
    transform: "translate(-158.101 -71.748)",
    fill: "#020000"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M255.58,118.142l2.944,2.948c.25-.02.5-.039.733-.062l-2.944-2.948c-.238.023-.483.043-.733.062Z",
    transform: "translate(-155.929 -72.04)",
    fill: "#020000"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M251.79,118.356l2.944,2.948c.265,0,.522-.012.776-.02l-2.944-2.944c-.253.012-.511.016-.776.02Z",
    transform: "translate(-153.617 -72.199)",
    fill: "#020000"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M224.507,93,221.77,90.26v.792c.85.85,1.7,1.692,2.542,2.542l.195-.6Z",
    transform: "translate(-135.302 -55.067)",
    fill: "#020000"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M247.79,118.31l2.948,2.952c.277.012.554.023.823.027l-2.948-2.948c-.074,0-.152-.008-.226-.008-.125,0-.246-.008-.37-.016C247.942,118.318,247.868,118.314,247.79,118.31Z",
    transform: "translate(-151.176 -72.181)",
    fill: "#020000"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M223.818,97.125l.047-.14.148-.456q-1.187-1.193-2.378-2.378c0,.109-.016.214-.023.324s-.016.207-.023.308a1.025,1.025,0,0,1-.008.109c.749.749,1.493,1.493,2.238,2.242Z",
    transform: "translate(-135.186 -57.441)",
    fill: "#020000"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M243.52,117.97l2.952,2.952c.292.031.585.058.873.078l-2.948-2.948a.3.3,0,0,1-.051,0c-.265-.023-.53-.047-.8-.074h-.027Z",
    transform: "translate(-148.571 -71.973)",
    fill: "#020000"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M238.97,117.35l2.952,2.952c.308.051.62.1.932.136l-2.948-2.952c-.039,0-.078-.012-.117-.016-.238-.031-.476-.066-.71-.105-.035,0-.07-.012-.105-.016Z",
    transform: "translate(-145.795 -71.595)",
    fill: "#020000"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M223.12,100.451l.195-.6q-1.07-1.076-2.141-2.141c0,.035-.016.07-.02.109-.016.09-.031.179-.051.269s-.035.2-.055.3c.69.686,1.38,1.38,2.07,2.07Z",
    transform: "translate(-134.862 -59.613)",
    fill: "#020000"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M220.19,101.554c.675.675,1.353,1.353,2.031,2.027l.195-.6-2.035-2.035C220.323,101.157,220.26,101.355,220.19,101.554Z",
    transform: "translate(-134.338 -61.589)",
    fill: "#020000"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M234.09,116.41l2.955,2.952c.324.07.659.14,1,.207l-2.952-2.952-.121-.023c-.269-.051-.53-.105-.788-.164C234.152,116.422,234.121,116.418,234.09,116.41Z",
    transform: "translate(-142.818 -71.022)",
    fill: "#020000"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M228.714,114.96l2.955,2.959c.343.113.721.222,1.119.328l-2.955-2.952a.649.649,0,0,0-.07-.019c-.374-.1-.721-.2-1.041-.308h-.012Z",
    transform: "translate(-139.536 -70.137)",
    fill: "#020000"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M221.129,106.521l.195-.6c-.682-.686-1.369-1.369-2.055-2.055-.043.1-.09.2-.136.3-.012.023-.02.047-.031.066-.027.059-.055.121-.082.179q1.053,1.053,2.105,2.109Z",
    transform: "translate(-133.624 -63.371)",
    fill: "#020000"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M220.074,108.693c-.729-.729-1.454-1.458-2.183-2.183-.062.105-.129.207-.191.308a.41.41,0,0,1-.027.043c-.027.043-.055.09-.082.136.975.979,1.957,1.953,2.932,2.932.058-.086.117-.168.172-.253l2.226,2.238c.253.129.507.261.764.386l-2.963-2.963c-.031-.016-.062-.031-.09-.043l-.643-.328.09-.273Z",
    transform: "translate(-132.751 -64.982)",
    fill: "#020000"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M215.86,109.293l2.936,2.936c.125-.14.246-.285.359-.437l-2.932-2.932c-.09.117-.187.23-.285.343a.524.524,0,0,0-.043.055c-.012.012-.02.023-.031.035Z",
    transform: "translate(-131.696 -66.415)",
    fill: "#020000"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M224.441,59.182c.035-.047.066-.1.1-.148L221.77,56.25v.265Q223.1,57.849,224.441,59.182Z",
    transform: "translate(-135.302 -34.318)",
    fill: "#020000"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M224.166,61.206,221.78,58.82v.791q1.059,1.059,2.113,2.117c.035-.082.086-.148.125-.226.051-.1.094-.2.148-.292Z",
    transform: "translate(-135.308 -35.886)",
    fill: "#020000"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M221.77,63.551l1.727,1.727a.055.055,0,0,1,.008-.023c.035-.129.074-.253.113-.374.023-.07.039-.14.062-.211-.639-.636-1.275-1.275-1.911-1.911v.8Z",
    transform: "translate(-135.302 -38.29)",
    fill: "#020000"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M223.3,68.809c.016-.136.031-.269.051-.4.008-.043.008-.09.016-.133-.534-.534-1.064-1.068-1.6-1.6v.8l1.509,1.509c0-.058.016-.113.023-.172Z",
    transform: "translate(-135.302 -40.681)",
    fill: "#020000"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M221.77,70.6V71.4c.5.5.994.994,1.489,1.489-.008-.164-.008-.331-.008-.5,0-.062-.012-.113-.012-.175a.819.819,0,0,1,.008-.1v-.043L221.774,70.6Z",
    transform: "translate(-135.302 -43.073)",
    fill: "#020000"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M221.77,74.54v.791c.6.6,1.2,1.2,1.794,1.8-.02-.074-.031-.156-.051-.23-.035-.14-.062-.281-.09-.425-.023-.121-.058-.23-.078-.355l-1.575-1.575Z",
    transform: "translate(-135.302 -45.477)",
    fill: "#020000"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M221.764,78.464v.791l2.932,2.932v-.444c-.062-.078-.105-.168-.164-.25a5.784,5.784,0,0,1-.48-.733.07.07,0,0,0-.019-.027L221.76,78.46Z",
    transform: "translate(-135.295 -47.868)",
    fill: "#020000"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M224.692,86.124v-.791q-1.468-1.468-2.932-2.932v.791c.643.643,1.283,1.287,1.926,1.926l1,1Z",
    transform: "translate(-135.295 -50.272)",
    fill: "#020000"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M224.692,90v-.741L221.76,86.33v.791l.792.792,2.125,2.129.012-.039Z",
    transform: "translate(-135.295 -52.67)",
    fill: "#020000"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M213.88,111.328l2.94,2.94c.144-.121.281-.25.413-.382l-2.94-2.936-.187.175c-.047.047-.1.09-.148.136-.027.023-.051.047-.078.07Z",
    transform: "translate(-130.488 -67.69)",
    fill: "#020000"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M211.64,113.091l2.94,2.94c.16-.105.316-.214.464-.331l-2.94-2.94c-.035.027-.074.051-.109.078l-.211.152c-.047.035-.094.07-.144.1Z",
    transform: "translate(-129.121 -68.795)",
    fill: "#020000"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M209.144,114.615l2.94,2.936c.175-.09.347-.183.511-.281l-2.94-2.94-.062.035c-.058.035-.121.066-.183.1-.09.051-.179.1-.269.148Z",
    transform: "translate(-127.596 -69.753)",
    fill: "#020000"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M206.41,115.88l2.944,2.94c.191-.07.378-.148.561-.23l-2.94-2.94h-.008a1.017,1.017,0,0,1-.1.039c-.152.066-.3.129-.46.187Z",
    transform: "translate(-125.93 -70.558)",
    fill: "#020000"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M203.41,116.905l2.944,2.944c.211-.058.417-.113.62-.175l-2.944-2.944-.2.059-.078.023c-.113.031-.222.066-.339.1Z",
    transform: "translate(-124.1 -71.217)",
    fill: "#020000"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M200.15,117.655l2.944,2.944c.226-.039.448-.078.671-.125l-2.944-2.944c-.1.02-.2.035-.3.055-.051.008-.1.019-.152.027-.07.012-.14.027-.214.039Z",
    transform: "translate(-122.111 -71.705)",
    fill: "#020000"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M196.634,118.15l2.944,2.944c.246-.02.487-.043.721-.07l-2.944-2.944c-.144.016-.292.027-.437.043-.055,0-.109.012-.168.016-.039,0-.078.008-.121.012Z",
    transform: "translate(-119.964 -72.04)",
    fill: "#020000"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M195.788,121.329c.261,0,.519,0,.78-.016l-2.948-2.944q-.345.012-.7.012h-.078l2.948,2.952Z",
    transform: "translate(-117.651 -72.217)",
    fill: "#020000"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M188.73,118.22l2.948,2.948c.277.023.558.039.842.051l-2.948-2.948a.5.5,0,0,1-.078,0c-.148-.008.027,0,0,0-.082,0-.16-.012-.242-.016-.105,0-.211-.012-.316-.02Z",
    transform: "translate(-115.144 -72.126)",
    fill: "#020000"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M185,117.73c-.058-.008-.023,0,0,0q-.409-.058-.819-.14l2.955,2.952c.308.058.62.109.944.152l-2.952-2.948s-.039,0-.058-.008h-.008a.3.3,0,0,1-.058-.008Z",
    transform: "translate(-112.368 -71.741)",
    fill: "#020000"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M178.644,115.994l2.963,2.963a11.646,11.646,0,0,0,1.181.39l-2.955-2.955c-.07-.02-.144-.039-.211-.062l-.066-.023c-.191-.058-.37-.125-.554-.191-.121-.043-.242-.078-.363-.125Z",
    transform: "translate(-108.988 -70.765)",
    fill: "#020000"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M171.457,111.48c-.09-.078-.179-.156-.265-.238-.055-.051-.117-.1-.172-.152l2.238,2.25a11.874,11.874,0,0,0,2.238,1.907l-2.979-2.979c-.07-.043-.136-.086-.207-.133-.039-.027-.078-.058-.117-.086-.113-.078-.222-.16-.331-.242q-.211-.158-.409-.328Z",
    transform: "translate(-104.339 -67.776)",
    fill: "#020000"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M134.854,76.091a2.656,2.656,0,0,0-.211-.616,1.756,1.756,0,0,0-.331-.464c-.031-.031-.066-.058-.1-.09a1.636,1.636,0,0,0-.359-.226,1.288,1.288,0,0,0-.129-.058,2.317,2.317,0,0,0-.4-.113.835.835,0,0,0-.105-.023l1.641,1.641s0-.035-.008-.051Z",
    transform: "translate(-81.277 -45.452)",
    fill: "#020000"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M132.578,76.87l-2.53-2.53H130a3.245,3.245,0,0,0-.62.066.264.264,0,0,0-.055.008l2.944,2.944a2.875,2.875,0,0,1,.32-.051v-.269c0-.058-.008-.113-.008-.172Z",
    transform: "translate(-78.904 -45.355)",
    fill: "#020000"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M130.2,77.986l-2.936-2.936c-.02.012-.039.027-.062.039a1.5,1.5,0,0,0-.32.253c-.019.019-.039.043-.058.066q1.468,1.462,2.932,2.928A1.578,1.578,0,0,1,130.2,77.986Z",
    transform: "translate(-77.373 -45.788)",
    fill: "#020000"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M128.707,80.048q-1.462-1.468-2.928-2.928l-.047.094a3.221,3.221,0,0,0-.113.343c-.016.051-.027.105-.039.156.975.979,1.95,1.95,2.924,2.928a2.635,2.635,0,0,1,.2-.593Z",
    transform: "translate(-76.616 -47.051)",
    fill: "#020000"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M125.288,80.612c0,.156-.008.312-.008.472l1.6,1.6h.8q-1.187-1.181-2.371-2.367c-.008.1-.016.187-.02.3Z",
    transform: "translate(-76.433 -49.003)",
    fill: "#020000"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M125.28,84.965l.07.07h.8l-.866-.866Z",
    transform: "translate(-76.433 -51.352)",
    fill: "#020000"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M154.187,63.083a7.154,7.154,0,0,1,.4.612c.035.058.078.113.113.172l2.9,2.9a11.661,11.661,0,0,0-1.926-2.339q-1.158-1.164-2.312-2.328c.043.043.082.086.121.129-.023-.023,0,0,.016.019s.047.058.074.09c.152.164.292.335.429.511.062.082.129.156.187.242Z",
    transform: "translate(-93.565 -37.887)",
    fill: "#020000"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M158.779,71.295l2.024,2.02v-.792L158.44,70.16c.023.066.039.136.062.2.09.257.168.519.238.791.012.047.031.094.043.14Z",
    transform: "translate(-96.664 -42.805)",
    fill: "#020000"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M161.6,78.06v-.8L159.76,75.42c.016.086.027.175.039.261.016.117.023.234.035.351.008.082.02.164.023.246v.035l1.743,1.743Z",
    transform: "translate(-97.469 -46.014)",
    fill: "#020000"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M161.818,82.2v-.791L160.11,79.7v.164c0,.035,0,.066,0,.1V80.5l1.7,1.7Z",
    transform: "translate(-97.683 -48.625)",
    fill: "#020000"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M160.13,84.435l1.7,1.7v-.792c-.565-.569-1.135-1.135-1.7-1.7Z",
    transform: "translate(-97.695 -51.029)",
    fill: "#020000"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M161.853,90.095c-.008-.207-.023-.409-.023-.624V89.28l-1.7-1.7v.792l1.723,1.727Z",
    transform: "translate(-97.695 -53.432)",
    fill: "#020000"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M160.12,92.3,162,94.181c-.047-.292-.078-.6-.105-.9l-1.77-1.77v.8Z",
    transform: "translate(-97.689 -55.83)",
    fill: "#020000"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M160.12,95.424v.792l2.421,2.421a10.01,10.01,0,0,1-.347-1.142L160.12,95.42Z",
    transform: "translate(-97.689 -58.216)",
    fill: "#020000"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M163.052,103.087v-.8L160.12,99.36v.8Z",
    transform: "translate(-97.689 -60.619)",
    fill: "#020000"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M163.052,107.017v-.8l-2.932-2.932v.8Z",
    transform: "translate(-97.689 -63.017)",
    fill: "#020000"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M160.12,108.012l2.932,2.932v-.791l-2.932-2.932v.792Z",
    transform: "translate(-97.689 -65.415)",
    fill: "#020000"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M160.12,111.945l2.928,2.928,0-.792-2.932-2.932Z",
    transform: "translate(-97.689 -67.812)",
    fill: "#020000"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M162.5,118.6h.2v-.589l-2.928-2.932v.569h-.222Z",
    transform: "translate(-97.341 -70.21)",
    fill: "#020000"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M158.568,119.492h.792l-2.948-2.952h-.792Z",
    transform: "translate(-94.944 -71.101)",
    fill: "#020000"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M154.638,119.492h.792l-2.948-2.952h-.792Z",
    transform: "translate(-92.546 -71.101)",
    fill: "#020000"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M150.7,119.492h.8l-2.948-2.952h-.8Z",
    transform: "translate(-90.142 -71.101)",
    fill: "#020000"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M146.778,119.492h.792l-2.948-2.952h-.792Z",
    transform: "translate(-87.75 -71.101)",
    fill: "#020000"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M142.838,119.492h.8l-2.948-2.952h-.8Z",
    transform: "translate(-85.347 -71.101)",
    fill: "#020000"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M140.612,119.492h.14L137.8,116.54h-.125Z",
    transform: "translate(-83.998 -71.101)",
    fill: "#020000"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M136.439,104.434l0,0h-.8l.8.8Z",
    transform: "translate(-82.754 -63.713)",
    fill: "#020000"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M132.5,104.43h-.792l2.328,2.332v-.483l0-.312Z",
    transform: "translate(-80.356 -63.713)",
    fill: "#020000"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M130.728,107.378h.8l-2.948-2.948h-.8Z",
    transform: "translate(-77.958 -63.713)",
    fill: "#020000"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M125.27,104.984l2.932,2.932v-.538h.257l-2.948-2.948h-.238v.554Z",
    transform: "translate(-76.427 -63.713)",
    fill: "#020000"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M125.27,108.545l2.932,2.932v-.8l-2.932-2.932Z",
    transform: "translate(-76.427 -65.738)",
    fill: "#020000"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M128.2,115.4v-.8l-2.932-2.932v.8Z",
    transform: "translate(-76.427 -68.13)",
    fill: "#020000"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M124.164,115.967q1.474,1.48,2.948,2.952h.409v-.386q-1.468-1.462-2.932-2.932v.367h-.429Z",
    transform: "translate(-75.75 -70.527)",
    fill: "#020000"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M123.182,119.492h.792q-1.474-1.474-2.948-2.952h-.8l2.948,2.952Z",
    transform: "translate(-73.352 -71.101)",
    fill: "#020000"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M99.552,59.685V59.2L96.62,56.25v.507Z",
    transform: "translate(-58.948 -34.318)",
    fill: "#020000"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M96.62,60.242l2.928,2.932,0-.8L96.62,59.45v.792Z",
    transform: "translate(-58.948 -36.27)",
    fill: "#020000"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M96.62,64.165l2.764,2.764s.008-.031.012-.051q.053-.234.117-.456c.012-.043.019-.086.031-.129L96.62,63.37v.792Z",
    transform: "translate(-58.948 -38.662)",
    fill: "#020000"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M96.61,68.1l2.538,2.538.023-.164c.023-.179.043-.359.074-.53L96.61,67.31v.8Z",
    transform: "translate(-58.942 -41.066)",
    fill: "#020000"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M96.6,71.23v.792l2.441,2.445c0-.1.008-.195.012-.292,0-.125.008-.257.016-.382V73.7L96.6,71.23Z",
    transform: "translate(-58.936 -43.457)",
    fill: "#020000"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M99.043,77.593,96.61,75.16v.8l2.433,2.429Z",
    transform: "translate(-58.942 -45.855)",
    fill: "#020000"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M99.043,81.523,96.61,79.09v.8l2.433,2.433Z",
    transform: "translate(-58.942 -48.253)",
    fill: "#020000"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M96.61,83.805l2.433,2.433v-.8L96.61,83.01V83.8Z",
    transform: "translate(-58.942 -50.644)",
    fill: "#020000"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M96.61,86.95v.8c.811.807,1.622,1.622,2.433,2.433v-.8Z",
    transform: "translate(-58.942 -53.048)",
    fill: "#020000"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M96.61,90.88v.792L99.039,94.1l0-.195v-.6Z",
    transform: "translate(-58.942 -55.446)",
    fill: "#020000"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M119.258,119.492h.8l-2.948-2.952h-.8Z",
    transform: "translate(-70.961 -71.101)",
    fill: "#020000"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M96.61,95.6l2.429,2.433v-.8L96.61,94.81V95.6Z",
    transform: "translate(-58.942 -57.843)",
    fill: "#020000"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M115.328,119.492h.8l-2.948-2.952h-.8Z",
    transform: "translate(-68.563 -71.101)",
    fill: "#020000"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M96.6,99.535l2.433,2.429v-.792L96.6,98.74Z",
    transform: "translate(-58.936 -60.241)",
    fill: "#020000"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M111.4,119.492h.8l-2.948-2.952h-.8Z",
    transform: "translate(-66.165 -71.101)",
    fill: "#020000"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M99.033,105.894V105.1L96.6,102.67v.792Z",
    transform: "translate(-58.936 -62.639)",
    fill: "#020000"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M107.468,119.492h.792l-2.944-2.952h-.8Z",
    transform: "translate(-63.767 -71.101)",
    fill: "#020000"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M96.6,107.391l2.433,2.433v-.8L96.6,106.6v.792Z",
    transform: "translate(-58.936 -65.036)",
    fill: "#020000"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M96.6,111.315l2.932,2.932v-.792L96.6,110.52Z",
    transform: "translate(-58.936 -67.428)",
    fill: "#020000"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M99.532,118.184v-.8L96.6,114.46v.791Z",
    transform: "translate(-58.936 -69.832)",
    fill: "#020000"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M95.678,119.5h.791l-2.948-2.948H92.73Z",
    transform: "translate(-56.574 -71.107)",
    fill: "#020000"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M91.748,119.5h.792l-2.948-2.948H88.8Z",
    transform: "translate(-54.177 -71.107)",
    fill: "#020000"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M87.812,119.5H88.6l-2.948-2.948h-.8Z",
    transform: "translate(-51.773 -71.107)",
    fill: "#020000"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M83.888,119.5h.792l-2.948-2.948H80.94Z",
    transform: "translate(-49.381 -71.107)",
    fill: "#020000"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M79.948,119.5h.8L77.8,116.55H77Z",
    transform: "translate(-46.978 -71.107)",
    fill: "#020000"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M77.1,119.5h.382l-2.948-2.948H74.17Z",
    transform: "translate(-45.251 -71.107)",
    fill: "#020000"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M361.824,75.567a2.1,2.1,0,0,0-2.269-2.207H355.96v4.41h3.595A2.106,2.106,0,0,0,361.824,75.567Zm-2.967,1.361h-2.063V74.206h2.753a2.1,2.1,0,0,1,.437.043c.019,0,.031.012.047.016a1.735,1.735,0,0,1,.285.1,1.05,1.05,0,0,1,.242.152.039.039,0,0,1,.016.019,1.085,1.085,0,0,1,.222.285c.008.016.016.027.023.043a1.389,1.389,0,0,1,.113.331v0a1.8,1.8,0,0,1,.039.367,1.773,1.773,0,0,1-.047.367,1.276,1.276,0,0,1-.082.273c0,.008-.008.016-.012.023a1.1,1.1,0,0,1-.136.222.1.1,0,0,0-.02.023,1.066,1.066,0,0,1-.425.316,1.332,1.332,0,0,1-.211.07.457.457,0,0,1-.078.023,1.891,1.891,0,0,1-.378.035c-.016,0-.027,0-.043,0h-.686Z",
    transform: "translate(-217.171 -44.757)",
    fill: "#00aeef"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M129.677,75.784c0-2.355-1.018-3.614-3.3-3.614s-3.228,1.259-3.228,3.614V78.56h6.527Zm-.854.2v1.727H123.98v-1.93c0-.055.008-.094.008-.144,0-.105.012-.2.02-.3a4.377,4.377,0,0,1,.09-.651,1.52,1.52,0,0,1,.039-.156,3.54,3.54,0,0,1,.113-.343c.016-.035.031-.062.047-.094a1.887,1.887,0,0,1,.289-.448c.019-.023.039-.047.058-.066a1.631,1.631,0,0,1,.32-.253c.019-.012.039-.027.062-.039a1.86,1.86,0,0,1,.538-.2.263.263,0,0,0,.055-.008,4.075,4.075,0,0,1,.62-.066h.133a3.894,3.894,0,0,1,.706.062l.105.023a2.318,2.318,0,0,1,.4.113l.129.058a1.915,1.915,0,0,1,.359.226.726.726,0,0,1,.1.09,1.7,1.7,0,0,1,.331.464,2.658,2.658,0,0,1,.211.616.228.228,0,0,0,.008.051,4.71,4.71,0,0,1,.09.83c0,.058.008.109.008.172v.265Z",
    transform: "translate(-75.134 -44.031)",
    fill: "#00aeef"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M38.046,79.761h7.673V72H51.47v7.755h8.745v-23.5H51.47v8.235H45.719V56.25H36.978L36.97,79.761h1.068Zm-.214-22.669h7.061v8.239h7.435V57.092h7.065V78.923H52.328V71.164H44.893v7.759H37.832Z",
    transform: "translate(-22.555 -34.318)",
    fill: "#00aeef"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M164.484,65.556v4.784c0,.214.016.417.023.624.012.265.023.53.047.784.027.308.058.612.105.9.051.32.121.628.195.932a10.007,10.007,0,0,0,.347,1.142,8.055,8.055,0,0,0,2,3.041c.086.082.175.16.265.238q.2.17.409.328c.109.082.218.164.331.242a9.4,9.4,0,0,0,2.16,1.076c.183.066.363.133.554.191a13.517,13.517,0,0,0,2.125.456h.008c.351.047.721.082,1.092.109.105.008.211.016.316.02.374.02.756.035,1.154.035.526,0,1.033-.023,1.525-.062.055,0,.109-.012.168-.016.448-.039.881-.1,1.3-.172.051-.008.1-.02.152-.027.429-.082.842-.175,1.24-.292l.078-.023a11.164,11.164,0,0,0,1.216-.433,1.016,1.016,0,0,0,.1-.039c.269-.117.53-.25.78-.386.062-.031.121-.066.183-.1.23-.133.448-.273.659-.421.07-.051.14-.1.211-.152q.31-.228.6-.48c.051-.043.1-.09.148-.136.2-.187.4-.382.581-.589a.524.524,0,0,0,.043-.055,8.214,8.214,0,0,0,.678-.908.409.409,0,0,1,.027-.043,8.945,8.945,0,0,0,.534-.971c.012-.023.02-.047.031-.066a9.78,9.78,0,0,0,.729-2.32c.016-.09.035-.179.051-.269.047-.285.082-.573.113-.869.008-.1.016-.2.023-.308.023-.324.039-.651.039-.99V56.23h-8.746V69.853c0,2.047-.706,2.64-1.938,2.749h-.043c-.152.012-.312.019-.48.019-.062,0-.117-.008-.175-.008h-.086a3.155,3.155,0,0,1-.885-.148l-.016,0a1.541,1.541,0,0,1-.908-.811c-.027-.055-.047-.117-.07-.175a3.6,3.6,0,0,1-.211-.947c-.016-.156-.023-.328-.027-.511,0-.055-.008-.1-.008-.16V69.7h0V56.242H164.48v9.315Zm.85-8.476H172.4V69.865c0,2.534,1.018,3.614,3.232,3.614s3.295-1.08,3.295-3.614V57.08h7.065V70.348c0,6.067-3.763,9.284-10.36,9.284s-10.293-2.8-10.293-9.284V57.08Z",
    transform: "translate(-100.349 -34.306)",
    fill: "#00aeef"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M224.53,60.962c-.02.129-.035.261-.051.4-.031.292-.055.6-.058.916,0,.035-.008.062-.008.1,0,.062.012.113.012.175a9.836,9.836,0,0,0,.172,1.677c.027.144.059.289.09.425a6.639,6.639,0,0,0,.546,1.474,6.076,6.076,0,0,0,.48.733,6.577,6.577,0,0,0,.932,1.025c.109.094.214.191.328.281a8.455,8.455,0,0,0,.858.577c.027.016.051.035.078.051a10.717,10.717,0,0,0,1.408.667c.051.019.113.035.164.055.308.117.628.226.963.328.129.039.257.082.394.121l2.581.534,1,.207.386.078a2.936,2.936,0,0,1,.725.292h0c.039.027.074.051.1.07a.052.052,0,0,0-.02.012,1.839,1.839,0,0,1-.554.183c-.047.008-.1.016-.152.027-.105.016-.222.027-.351.039l-.218.012c-.066,0-.117.008-.187.008-.179,0-.37-.008-.558-.016h-.082c-.2-.008-.409-.02-.616-.035-.047,0-.1-.008-.144-.012-.273-.023-.546-.051-.827-.086a.16.16,0,0,1-.043,0c-.261-.031-.519-.074-.78-.117-.039-.008-.078-.016-.117-.019-.316-.055-.628-.121-.936-.195-.09-.019-.179-.043-.265-.062s-.172-.043-.257-.066h0a8.907,8.907,0,0,1-2.312-.963l-.916-.577L225.15,72.78l-.047.14-.183.558-.195.6-.179.558-.195.6-.183.558-.195.6-.183.558-.09.273.643.328a9.54,9.54,0,0,0,1.31.519c.32.105.667.207,1.041.308.359.1.745.187,1.142.277.257.055.519.109.788.164.367.07.745.136,1.127.2.234.039.472.074.71.105.328.047.655.086.986.121.265.027.53.055.8.074.359.027.714.051,1.064.066.125,0,.25.012.37.016.2,0,.4.008.6.008a23.01,23.01,0,0,0,3.6-.261c.086-.016.175-.027.261-.043.281-.047.55-.105.811-.164l.331-.082c.261-.066.519-.136.76-.218.066-.019.129-.047.191-.066a10.256,10.256,0,0,0,1.166-.487.209.209,0,0,1,.043-.02,7.772,7.772,0,0,0,1.01-.6c.043-.031.086-.055.125-.086.183-.136.351-.285.519-.433.066-.062.133-.121.195-.187a6.253,6.253,0,0,0,1.24-1.755c.031-.062.062-.121.09-.183a6.629,6.629,0,0,0,.238-.643c.031-.094.058-.191.086-.289a8.527,8.527,0,0,0,.234-1.139.2.2,0,0,1,.008-.047,9.834,9.834,0,0,0,.09-1.248c0-.058.008-.113.008-.172,0-.078-.008-.148-.008-.222a8.027,8.027,0,0,0-.6-3.143,4.363,4.363,0,0,0-.234-.468c-.031-.055-.058-.105-.09-.16A5.582,5.582,0,0,0,242.9,65.7c-.066-.051-.136-.1-.207-.148-.121-.086-.242-.168-.37-.25l-.175-.105c-.168-.1-.343-.195-.522-.289a14.909,14.909,0,0,0-1.474-.647c-.331-.125-.671-.246-1.033-.367-.312-.1-.636-.2-.975-.3l-3.794-.854a3.245,3.245,0,0,1-.628-.234c.02-.016.062-.035.094-.055a1.941,1.941,0,0,1,.554-.187c.051-.012.1-.023.156-.031s.086-.016.133-.019c.129-.016.273-.023.429-.027.031,0,.051,0,.082,0,.246,0,.456.023.686.031.281.012.569.016.83.039.308.027.589.086.873.133.121.019.25.039.37.062.16.035.324.066.476.109.058.016.113.039.175.055a9.369,9.369,0,0,1,1.139.4,9.544,9.544,0,0,1,.916.456c.027.016.058.027.09.043l.877.522.324-.9.062-.175.257-.717.148-.409.195-.542.211-.585.195-.542.211-.585.195-.546.211-.585.195-.546.211-.585.195-.546.1-.269-.667-.331a20.834,20.834,0,0,0-8.656-1.692c-3.256,0-7.95.659-9.8,4.371-.039.078-.086.148-.125.226a6.979,6.979,0,0,0-.269.745c-.039.125-.082.246-.113.374a7.653,7.653,0,0,0-.152.768ZM235,55.316a19.907,19.907,0,0,1,8.282,1.6l-2.1,5.872a11.168,11.168,0,0,0-5.985-1.454c-1.38,0-2.336.48-2.336,1.185,0,.48.308.737,1.31,1.025l3.79.854c4.449,1.318,6.507,2.6,6.507,6.87,0,4.995-3.209,7.283-10.161,7.283a27.137,27.137,0,0,1-9.553-1.762l2.027-6.238a15.4,15.4,0,0,0,7.393,1.716c1.415,0,2.371-.409,2.371-1.115,0-.55-.585-.932-1.517-1.189l-3.973-.823c-3.829-1.061-5.786-2.909-5.786-6.773,0-4.117,2.706-7.057,9.732-7.057Z",
    transform: "translate(-136.479 -33.232)",
    fill: "#00aeef"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M282.384,79.779h18.649V72.27H290.806V71.6h8.956V64.569h-8.956V63.8H300.5V56.28H282.384V73.252l0,.8v5.743Zm.854-22.669h16.434V62.94h-9.693V65.4h8.956v5.349h-8.956V73.1h10.227v5.837H283.238Z",
    transform: "translate(-172.28 -34.336)",
    fill: "#00aeef"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M335.654,64.875v.214l0,14.672H344.4V74.326c.339.347.682.71,1.033,1.084a29.636,29.636,0,0,0,2.363,2.324c.066.055.129.113.2.168.242.195.487.382.741.561.094.066.191.129.289.195.238.156.483.3.737.437.062.035.121.07.187.105a8.087,8.087,0,0,0,2.273.76.409.409,0,0,1,.066.016,8.474,8.474,0,0,0,1.361.109,10.2,10.2,0,0,0,1.033-.058c.082-.008.164-.02.246-.031a9.992,9.992,0,0,0,1.384-.273c.078-.02.152-.039.226-.062.2-.058.394-.121.585-.191.136-.051.265-.109.4-.168.109-.047.222-.09.324-.14l.335-.168.195-.1-.066-.565-.1-.834-.105-.9-.136-1.158-.066-.577-.359-3.061-.881.289-.1.031a3.289,3.289,0,0,1-.491.113.228.228,0,0,0-.051.008c-.214.035-.441.058-.667.074-.02,0-.043,0-.062,0-.172.008-.339.016-.487.016a1.578,1.578,0,0,1-.246-.027,2.029,2.029,0,0,1-1.314-.788c.168-.086.331-.187.491-.285.1-.058.195-.121.292-.183.164-.113.328-.226.483-.351.066-.051.129-.109.191-.164a7.848,7.848,0,0,0,1.431-1.595c.012-.016.023-.035.035-.051a8.034,8.034,0,0,0,1-2.133c.02-.058.039-.117.055-.175a7.767,7.767,0,0,0,.179-.846c.019-.113.035-.222.047-.335a7.716,7.716,0,0,0,.062-.9c0-.019,0-.039,0-.058,0-.09-.008-.172-.012-.261a10.21,10.21,0,0,0-.121-1.369c-.027-.179-.066-.351-.1-.522a8.2,8.2,0,0,0-.53-1.618,7.3,7.3,0,0,0-.472-.881l-.047-.082a6.548,6.548,0,0,0-.651-.842,8.684,8.684,0,0,0-6.706-2.612H335.65v8.621Zm.85-7.782h12.383c4.819,0,7.8,2.686,7.8,7.35a7.042,7.042,0,0,1-4.909,6.765c.975.881,1.466,1.969,3.037,1.969a7.354,7.354,0,0,0,2.024-.257l.639,5.486a8.837,8.837,0,0,1-3.821.834c-4.878,0-7.1-4.5-10.091-6.812v6.488H336.5V57.084Z",
    transform: "translate(-204.779 -34.318)",
    fill: "#00aeef"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M103.057,62.075c-.031.172-.051.351-.074.53q-.058.45-.094.924c-.008.125-.008.257-.016.382-.008.207-.023.409-.023.624v14.1h8.742V73.917h4.843v4.726h8.749V64.536c0-.035,0-.066,0-.1,0-.331-.016-.655-.039-.971l-.023-.246a11.622,11.622,0,0,0-.292-1.669c-.07-.273-.148-.534-.238-.791a8.881,8.881,0,0,0-.815-1.751c-.125-.211-.257-.413-.4-.612-.058-.082-.125-.16-.187-.242-.136-.175-.277-.347-.429-.511-1.922-2.082-4.913-3.232-8.769-3.232-5.833,0-9.455,2.254-10.672,6.55-.043.148-.078.3-.117.456-.051.214-.1.433-.14.659Zm.643,2.46c0-6.492,3.942-9.284,10.293-9.284s10.36,3.209,10.36,9.284V77.8h-7.061V73.075h-6.527V77.8H103.7V64.536Z",
    transform: "translate(-62.749 -33.195)",
    fill: "#00aeef"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M46.251,72.482h7.435v7.759h7.065V58.41H53.687v8.239H46.251V58.41H39.19V80.241h7.061V72.482ZM55,79.73h-.92V72.813H55ZM46.727,66.98h7.357V58.745H60.3v.842H55v8.235H46.727Zm-.92-7.4h-5.3V79.726h-.92V58.741h6.219Z",
    transform: "translate(-23.91 -35.636)",
    fill: "#fff"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M176.973,80.952c6.593,0,10.36-3.217,10.36-9.284V58.4h-7.065V71.185c0,2.534-1.014,3.614-3.295,3.614s-3.232-1.08-3.232-3.614V58.4H166.68V71.668C166.68,78.152,170.446,80.952,176.973,80.952Zm-.027-5.821c2.538,0,3.716-1.283,3.716-4.035V58.731h6.219v.842h-5.3V71.937c0,2.753-1.181,4.032-3.716,4.032a3.322,3.322,0,0,1-3-1.294,4.261,4.261,0,0,0,2.078.452Zm-9.872-16.4h6.219v.842h-5.3V72.421a8.908,8.908,0,0,0,1.961,6.18c-1.93-1.458-2.881-3.79-2.881-7.022Z",
    transform: "translate(-101.691 -35.63)",
    fill: "#fff"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M232.7,70.476l3.973.823c.932.257,1.517.639,1.517,1.189,0,.706-.955,1.115-2.371,1.115a15.386,15.386,0,0,1-7.393-1.716L226.4,78.126a27.137,27.137,0,0,0,9.553,1.762c6.952,0,10.161-2.285,10.161-7.283,0-4.273-2.059-5.552-6.507-6.87l-3.79-.854c-1-.289-1.31-.546-1.31-1.025,0-.706.955-1.185,2.336-1.185a11.151,11.151,0,0,1,5.985,1.454l2.1-5.872a19.845,19.845,0,0,0-8.281-1.6c-7.026,0-9.732,2.94-9.732,7.057,0,3.86,1.957,5.712,5.786,6.773Zm4.016,4.3a16.674,16.674,0,0,1-7.155-1.513l-1.6,4.924c-.409-.125-.772-.253-1.072-.378l1.751-5.385a16.731,16.731,0,0,0,7.155,1.513c1.747,0,2.792-.573,2.792-1.532a1.113,1.113,0,0,0-.1-.456c.675.328,1.018.76,1.018,1.3,0,.963-1.045,1.536-2.792,1.536Zm-1.045-9.58,3.817.862c2.449.725,4.1,1.419,5.073,2.593a14.267,14.267,0,0,0-4.152-1.755l-3.817-.862c-.69-.2-1.365-.448-1.556-1.057a6.078,6.078,0,0,0,.636.214Zm.951-8.219a20.219,20.219,0,0,1,7.759,1.4l-.152.429a22.026,22.026,0,0,0-6.683-.986c-6.09,0-9.307,2.293-9.307,6.636a5.963,5.963,0,0,0,1.267,4.055,5.543,5.543,0,0,1-2.187-4.9c0-4.34,3.221-6.636,9.307-6.636Z",
    transform: "translate(-138.126 -34.562)",
    fill: "#fff"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M301.549,74.4H291.321V72.053h8.956V66.7h-8.956V64.239h9.693V58.41H284.58V80.241h16.969ZM291.8,67.035h8.036v.842H291.8v-.842Zm-5.9,12.7h-.92V58.745h15.588v.842H285.894V79.73ZM301.1,75.581H291.8v-.842H301.1Z",
    transform: "translate(-173.622 -35.636)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M344.911,73.755c2.987,2.312,5.213,6.812,10.091,6.812a8.837,8.837,0,0,0,3.821-.834l-.639-5.486a7.353,7.353,0,0,1-2.024.257c-1.571,0-2.063-1.088-3.037-1.969a7.042,7.042,0,0,0,4.909-6.765c0-4.663-2.979-7.35-7.8-7.35H337.85V80.251h7.061V73.763Zm11.221,1.076a9.374,9.374,0,0,0,1.661-.148l.109.951c-.3.027-.6.039-.85.039a3.285,3.285,0,0,1-2.6-1.341A2.889,2.889,0,0,0,356.132,74.831Zm-8.449.951c-.413-.441-.819-.873-1.228-1.275a27.343,27.343,0,0,1,2.148,2.117c.452.48.9.963,1.376,1.423a27.958,27.958,0,0,1-2.3-2.265Zm1.716-5.954h-4.016v-.842h3.1a2.517,2.517,0,0,0,2.69-2.624,2.779,2.779,0,0,0-.409-1.478,2.65,2.65,0,0,1-1.361,4.948Zm-4.492-1.174v-4.41H348.5a2.1,2.1,0,0,1,2.269,2.207,2.126,2.126,0,0,1-2.269,2.2ZM339.16,79.736h-.92V58.751H350.2a7.436,7.436,0,0,1,5.8,2.23,8.1,8.1,0,0,0-4.882-1.388H339.16Z",
    transform: "translate(-206.122 -35.642)",
    fill: "#fff"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M112.1,74.382h6.527v4.726h7.061V65.844c0-6.075-3.942-9.284-10.36-9.284s-10.293,2.792-10.293,9.284V79.108h7.061V74.382ZM119.94,78.6h-.92V74.714h.92Zm0-8.391h-7.369v-.842h6.449v-3.2a4.708,4.708,0,0,0-.686-2.71c1.064.608,1.606,1.8,1.606,3.552V70.2ZM112.1,69.033V66.257c0-2.355,1.018-3.614,3.228-3.614s3.3,1.259,3.3,3.614v2.776H112.1ZM106.348,66.6v12h-.92V65.754c0-5.88,3.322-8.862,9.872-8.862,3.544,0,6.2.963,7.876,2.788a11.225,11.225,0,0,0-6.956-1.95c-6.55,0-9.872,2.983-9.872,8.862Z",
    transform: "translate(-64.079 -34.507)",
    fill: "#fff"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M230.911,69.023a5.963,5.963,0,0,1-1.267-4.055c0-4.343,3.221-6.636,9.307-6.636a22.007,22.007,0,0,1,6.683.986l.152-.429a20.219,20.219,0,0,0-7.759-1.4c-6.09,0-9.307,2.3-9.307,6.636a5.539,5.539,0,0,0,2.187,4.9Z",
    transform: "translate(-139.542 -35.075)",
    fill: "#00aeef"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M130.123,74.26a4.7,4.7,0,0,1,.686,2.71v3.2H124.36v.842h7.369V77.816c0-1.755-.542-2.94-1.606-3.552Z",
    transform: "translate(-75.872 -45.306)",
    fill: "#00aeef"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M250.1,79.083l3.817.862a14.267,14.267,0,0,1,4.152,1.755c-.975-1.177-2.624-1.868-5.073-2.593l-3.817-.862a6.073,6.073,0,0,1-.636-.214c.195.608.866.858,1.556,1.057Z",
    transform: "translate(-151.634 -47.606)",
    fill: "#00aeef"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M190.678,76.5c2.538,0,3.716-1.283,3.716-4.032V60.1h5.3V59.26h-6.219V71.624c0,2.753-1.181,4.035-3.716,4.035a4.261,4.261,0,0,1-2.078-.452,3.322,3.322,0,0,0,3,1.294Z",
    transform: "translate(-114.503 -36.154)",
    fill: "#00aeef"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M383.025,100.571c.253,0,.55-.012.85-.039l-.109-.951a9.021,9.021,0,0,1-1.661.148,2.889,2.889,0,0,1-1.684-.5,3.285,3.285,0,0,0,2.6,1.341Z",
    transform: "translate(-232.094 -60.54)",
    fill: "#00aeef"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M362.547,74.984a2.815,2.815,0,0,1,.409,1.478,2.515,2.515,0,0,1-2.69,2.624h-3.1v.842h4.016a2.65,2.65,0,0,0,1.361-4.948Z",
    transform: "translate(-217.909 -45.745)",
    fill: "#00aeef"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M66.792,60.1h5.3V59.26H65.871V67.5H58.51v.838h8.282Z",
    transform: "translate(-35.697 -36.154)",
    fill: "#00aeef"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    "data-name": "Rectangle 1738",
    width: 8.036,
    height: 0.842,
    transform: "translate(118.171 31.399)",
    fill: "#00aeef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    width: 9.307,
    height: 0.842,
    transform: "translate(118.171 39.099)",
    fill: "#00aeef"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 0.92,
    height: 3.883,
    transform: "translate(54.937 40.211)",
    fill: "#00aeef"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M301.188,59.26H285.6V80.245h.916V60.1h14.672Z",
    transform: "translate(-174.244 -36.154)",
    fill: "#00aeef"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M239.25,95.858a1.127,1.127,0,0,1,.1.456c0,.963-1.045,1.532-2.792,1.532a16.674,16.674,0,0,1-7.155-1.513l-1.751,5.385a10.733,10.733,0,0,0,1.072.378l1.6-4.924a16.732,16.732,0,0,0,7.155,1.513c1.747,0,2.792-.573,2.792-1.536,0-.538-.343-.971-1.018-1.3Z",
    transform: "translate(-138.889 -58.478)",
    fill: "#00aeef"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M356.614,61.49a7.417,7.417,0,0,0-5.8-2.23H338.85V80.245h.92V60.1h11.962a8.111,8.111,0,0,1,4.882,1.388Z",
    transform: "translate(-206.732 -36.154)",
    fill: "#00aeef"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M40.2,80.245h.92V60.1h5.3V59.26H40.2Z",
    transform: "translate(-24.526 -36.154)",
    fill: "#00aeef"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M359.93,99.68c.409.406.811.834,1.228,1.275a27.954,27.954,0,0,0,2.3,2.265c-.472-.46-.924-.944-1.376-1.423A27.365,27.365,0,0,0,359.93,99.68Z",
    transform: "translate(-219.593 -60.815)",
    fill: "#00aeef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 0.92,
    height: 6.917,
    transform: "translate(30.174 37.177)",
    fill: "#00aeef"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M170.581,79.135a8.889,8.889,0,0,1-1.961-6.18V60.112h5.3V59.27H167.7V72.113c0,3.236.951,5.568,2.881,7.022Z",
    transform: "translate(-102.313 -36.161)",
    fill: "#00aeef"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M123.8,60.208c-1.673-1.825-4.332-2.788-7.876-2.788-6.55,0-9.872,2.983-9.872,8.862V79.126h.92v-12c0-5.88,3.322-8.862,9.872-8.862a11.225,11.225,0,0,1,6.956,1.95Z",
    transform: "translate(-64.701 -35.032)",
    fill: "#00aeef"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M54.023,188.39c-.37,1.478-.741,2.979-1.1,4.492q4.7-.994,9.436-1.856c-1.353-.441-2.714-.877-4.071-1.3l-4.262-1.333Z",
    transform: "translate(-32.286 -114.936)",
    fill: "#c6401d"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M169.03,150.724l-1.544-.3.3-1.544.218-1.139.421-2.2a320.37,320.37,0,0,0-114.561,0l.394,2.059.246,1.283.3,1.544-1.544.3q-2.334.444-4.663.924c-.7.144-1.408.292-2.109.441,1.38,1.688,2.55,3.135,3.618,4.484l.483.608-.191.753-.07.269,4.207-.807c3.041-.585,6.153-1.131,9.256-1.622l1.548-.246.012.07c3.708-.561,7.135-1.022,10.434-1.4,3.2-.37,6.691-.706,10.652-1.025,8.192-.659,16.508-.994,24.716-.994s16.524.335,24.712.994c3.958.32,7.439.655,10.64,1.025,3.295.382,6.722.842,10.43,1.4l.012-.066,1.552.246c3.127.5,6.231,1.041,9.229,1.618l4.538.869c-.023-.105-.047-.211-.066-.316l-.148-.694.421-.569c1.018-1.38,2.121-2.858,3.431-4.577q-1.111-.234-2.222-.464-2.322-.474-4.648-.92Zm-14.578.994c-.788-.113-1.177-.168-1.965-.277.32-2.332.48-3.5.8-5.825,1.345.183,2.016.281,3.357.476a2.042,2.042,0,0,1,1.907,2.293c-.129.823-1.634,1.447-1.634,1.447a3.035,3.035,0,0,0,1.271.877,2.782,2.782,0,0,0,.339.027,2.3,2.3,0,0,0,.238-.008c-.019.6-.031.893-.051,1.489a2.39,2.39,0,0,1-.425.074c-.039,0-.078.008-.117.008s-.082.008-.125.008a3.257,3.257,0,0,1-.425-.031c-1.357-.211-2.137-1.766-2.885-2.5-.109.776-.168,1.166-.281,1.942Zm-6.706-6.812c.8.1,1.2.144,2.008.246-.292,2.336-.441,3.5-.733,5.837l-1.969-.242C147.328,148.412,147.468,147.242,147.745,144.907Zm-8.219,5.041c-.8-.074-1.193-.113-1.992-.179,1.092-2.265,1.645-3.4,2.768-5.657.951.09,1.427.136,2.374.234.663,2.433.986,3.649,1.614,6.086-.8-.086-1.193-.129-1.988-.211-.09-.37-.133-.554-.222-.928l-2.168-.214c-.156.347-.234.519-.39.869Zm-11.869-.932a5.883,5.883,0,0,1-.85.078c-.031,0-.055.008-.086.008-.094,0-.187,0-.281-.008-1.392-.07-2.215-.8-2.172-1.817.031-.733,1.447-1.439,1.454-1.466.02-.078-.612-.76-.589-1.306a1.548,1.548,0,0,1,.043-.3c.008-.031.023-.062.031-.094a1.467,1.467,0,0,1,.066-.183.831.831,0,0,1,.062-.1,1.246,1.246,0,0,1,.1-.148c.027-.031.062-.062.094-.094a1.373,1.373,0,0,1,.136-.121,1.025,1.025,0,0,1,.129-.078,1.78,1.78,0,0,1,.172-.094,1.013,1.013,0,0,1,.164-.058c.07-.023.14-.047.214-.066s.129-.027.2-.039.172-.027.261-.035a2.309,2.309,0,0,1,.238-.012c.055,0,.1-.008.152-.008.094,0,.191,0,.292.008,1.5.078,2.265.7,2.211,1.614-.047.8-.764,1.306-1.614,1.563l.663.636a6.713,6.713,0,0,0,1.189-1.162c.53.444.8.667,1.322,1.115a8.568,8.568,0,0,1-1.318,1.189c.433.417.651.628,1.08,1.049-.008.109-.012.16-.019.269-.8-.055-1.2-.078-2-.125-.172-.183-.257-.277-.433-.46a5.865,5.865,0,0,1-.792.218C127.735,149,127.7,149.012,127.658,149.016Zm-16.493-3.326a3.383,3.383,0,0,1,.066-.675c.016-.07.047-.133.062-.2a2.452,2.452,0,0,1,.129-.394c.035-.078.086-.144.125-.218a3.192,3.192,0,0,1,.175-.3c.051-.07.117-.125.175-.191a2.67,2.67,0,0,1,.226-.242c.066-.058.144-.1.218-.156.09-.062.172-.133.269-.187.082-.047.172-.078.257-.117a2.652,2.652,0,0,1,.3-.133c.094-.031.191-.047.289-.07a3.151,3.151,0,0,1,.331-.078c.1-.016.207-.016.312-.023s.218-.027.331-.027h.051a4.244,4.244,0,0,1,2.48.8c-.374.565-.558.85-.928,1.419a2.612,2.612,0,0,0-1.525-.472,1.546,1.546,0,0,0-.3.047,1.3,1.3,0,0,0-.214.035,1.113,1.113,0,0,0-.246.148,1.05,1.05,0,0,0-.156.1,18.119,18.119,0,0,0-.269.4,1.5,1.5,0,0,0-.1.55,1.217,1.217,0,0,0,1.349,1.283,2.221,2.221,0,0,0,.265-.023c.043,0,.078,0,.121-.012a3.735,3.735,0,0,0,.429-.1c0-.179,0-.269.008-.448-.487-.008-.729-.008-1.213-.016,0-.491.008-.737.012-1.228,1.189.012,1.786.02,2.975.043-.023,1.084-.031,1.626-.055,2.706a3.023,3.023,0,0,1-.53.312c-.07.035-.156.058-.23.09-.144.058-.285.121-.444.172-.094.031-.195.047-.292.07a4.4,4.4,0,0,1-.448.105c-.105.019-.2.016-.308.027a3.723,3.723,0,0,1-.409.039h-.035a3.025,3.025,0,0,1-3.256-3.037Zm-7.3,3.022c-.791.019-1.189.031-1.981.055-.07-2.351-.105-3.529-.179-5.88.7-.023,1.045-.031,1.743-.047,1.018,1.119,1.525,1.677,2.523,2.8-.019-1.142-.027-1.712-.047-2.854.807-.016,1.213-.02,2.02-.027.023,2.355.035,3.529.058,5.884-.682.008-1.025.012-1.708.023-.99-1.127-1.489-1.688-2.5-2.807.027,1.139.039,1.712.066,2.854Zm-7.728-5.607c.807-.039,1.209-.058,2.016-.09.1,2.351.148,3.525.246,5.876-.791.031-1.189.051-1.977.09-.113-2.351-.172-3.525-.285-5.876Zm-4.433,6.141c-.792.051-1.185.074-1.977.133-.113-1.587-.168-2.378-.281-3.969-.655.047-.983.07-1.638.121-.058-.756-.086-1.139-.144-1.9,2.125-.16,3.185-.234,5.31-.355.047.76.066,1.139.113,1.9-.655.039-.983.058-1.638.1.1,1.587.152,2.382.253,3.973Zm-7.981-.289c-.866.078-1.3.117-2.168.2-.086.37-.133.558-.218.924-.8.078-1.193.121-1.988.2.639-2.433.967-3.649,1.641-6.079.951-.094,1.427-.136,2.374-.222,1.115,2.261,1.661,3.4,2.741,5.665-.8.066-1.193.1-1.992.172-.156-.347-.238-.522-.394-.866Zm-12.7-3.614c2.047-.265,3.072-.39,5.123-.624.074.651.113.979.187,1.634-1.279.144-1.918.222-3.193.378.027.207.039.308.066.515,1.01-.125,1.517-.187,2.527-.3.07.6.105.9.175,1.505-1.006.117-1.509.175-2.515.3.027.222.043.335.07.558,1.267-.156,1.9-.23,3.166-.374.074.651.113.979.187,1.634-2.012.226-3.018.351-5.03.612-.3-2.336-.456-3.5-.76-5.833ZM66.045,149.8c-.862.129-1.294.195-2.156.328l.331,2.137c-.784.121-1.177.183-1.961.312-.378-2.324-.565-3.486-.944-5.806.8-.129,1.2-.191,2-.316.129.819.191,1.228.32,2.051.866-.136,1.3-.2,2.168-.331-.121-.823-.183-1.232-.3-2.055.8-.117,1.2-.179,2-.292.331,2.328.5,3.494.827,5.825-.784.109-1.178.168-1.965.285-.129-.854-.191-1.283-.32-2.141Z",
    transform: "translate(-28.357 -85.646)",
    fill: "#c6401d"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M351.533,189.583q-2.029.637-4.063,1.3c3.189.581,6.379,1.209,9.541,1.879-.312-1.54-.632-3.08-.955-4.6Z",
    transform: "translate(-211.991 -114.796)",
    fill: "#c6401d"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M169.558,147.655q-2.334-.48-4.671-.924.468-2.445.936-4.893-7.936-1.48-15.9-2.554c-.222-.031-.441-.066-.663-.094q-13.838-1.842-27.734-2.488c-.257-.012-.511-.016-.768-.027-2.215-.1-4.425-.179-6.64-.23-.714-.016-1.427-.012-2.141-.023-1.758-.027-3.513-.062-5.271-.062h0c-.881,0-1.762.023-2.644.031-1.587.012-3.178.02-4.765.055-.791.02-1.579.059-2.371.082-1.677.051-3.357.1-5.034.175a322.632,322.632,0,0,0-34.615,3.5c-3.232.5-6.461,1.033-9.685,1.634q.468,2.445.936,4.893-2.345.45-4.683.928-2.322.474-4.632.983c.23.277.452.561.678.838q2.3,2.79,4.546,5.615-1.035,4.041-1.973,8.1,8.919-1.948,17.92-3.427c-.183-1.158-.37-2.32-.554-3.478-.066-.409-.136-.854-.218-1.361,3.969-.616,7.942-1.17,11.919-1.63,3.529-.409,7.065-.733,10.6-1.018q12.282-.988,24.587-.99h0q12.3,0,24.587.99c3.533.285,7.061.612,10.59,1.018,3.977.46,7.946,1.014,11.915,1.63q-.386,2.421-.772,4.839,9.013,1.48,17.92,3.427-.79-4.024-1.653-8.036c1.408-1.914,2.842-3.809,4.285-5.7.211-.273.413-.554.624-.827q-2.322-.509-4.648-.986Zm-125,13.487c.363-1.513.729-3.014,1.1-4.492l4.262,1.333c1.357.425,2.718.858,4.071,1.3-3.147.577-6.3,1.2-9.436,1.856Zm114.849-1.86q2.029-.667,4.063-1.3l4.523-1.423q.491,2.293.955,4.6c-3.162-.667-6.351-1.294-9.541-1.879Zm8.629-5.049-.421.569.148.694c.023.105.047.211.066.316l-4.538-.869c-3-.577-6.106-1.119-9.229-1.618l-1.552-.246-.012.066c-3.708-.561-7.135-1.022-10.43-1.4-3.2-.37-6.683-.706-10.64-1.025-8.188-.659-16.5-.994-24.712-.994s-16.524.335-24.716.994c-3.961.32-7.447.655-10.652,1.025-3.3.382-6.73.842-10.434,1.4l-.012-.07-1.548.246c-3.1.5-6.219,1.041-9.256,1.622l-4.207.807.07-.269.191-.753-.483-.608c-1.068-1.353-2.238-2.8-3.618-4.484q1.053-.222,2.109-.441,2.328-.48,4.663-.924l1.544-.3-.3-1.544-.246-1.283-.394-2.059a320.371,320.371,0,0,1,114.561,0l-.421,2.2-.218,1.139-.3,1.544,1.544.3q2.328.444,4.648.92,1.111.228,2.222.464c-1.31,1.719-2.413,3.2-3.431,4.577Z",
    transform: "translate(-23.922 -83.193)",
    fill: "#a0252b"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M326.1,159.544a.125.125,0,0,0,.027-.039.514.514,0,0,0,.051-.148.451.451,0,0,0-.421-.519l-1.014-.148c-.051.355-.078.534-.129.889.405.058.608.086,1.01.148a.649.649,0,0,0,.175,0,.252.252,0,0,0,.078-.016.449.449,0,0,0,.1-.047.262.262,0,0,0,.055-.035.376.376,0,0,0,.07-.086Z",
    transform: "translate(-198.044 -96.817)",
    fill: "#c6401d"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M253.355,151.379a.484.484,0,0,0-.226.055c-.027.012-.07.012-.09.027a.276.276,0,0,0-.109.211.645.645,0,0,0,.265.5.224.224,0,0,0,.117-.02.426.426,0,0,0,.066-.02.572.572,0,0,0,.109-.07l.07-.047a.858.858,0,0,0,.1-.105c.016-.02.035-.035.051-.058a.378.378,0,0,0,.07-.168c.008-.14-.105-.285-.425-.3Z",
    transform: "translate(-154.312 -92.356)",
    fill: "#c6401d"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M137.35,156.452c.483-.047.725-.07,1.213-.113-.3-.667-.46-1-.768-1.669-.179.71-.265,1.068-.444,1.782Z",
    transform: "translate(-83.797 -94.364)",
    fill: "#c6401d"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M287.7,156.681c.483.047.725.07,1.209.121-.172-.714-.261-1.072-.437-1.782-.312.663-.464,1-.772,1.665Z",
    transform: "translate(-175.525 -94.577)",
    fill: "#c6401d"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M251.249,156.963c-.012.242.156.511.624.534a1.7,1.7,0,0,0,.456-.047c-.324-.339-.487-.511-.815-.85a.535.535,0,0,0-.265.359Z",
    transform: "translate(-153.286 -95.541)",
    fill: "#c6401d"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M90.7,154.34c-.8.113-1.2.172-2,.292.121.819.183,1.232.3,2.055-.866.129-1.3.195-2.168.331-.129-.819-.191-1.232-.32-2.051-.8.125-1.2.187-2,.316.378,2.324.565,3.482.944,5.806.784-.129,1.178-.191,1.961-.312l-.331-2.137c.862-.133,1.294-.2,2.156-.328.129.858.191,1.283.32,2.141.784-.117,1.178-.175,1.965-.285-.331-2.328-.5-3.494-.827-5.825Z",
    transform: "translate(-51.566 -94.163)",
    fill: "#fff"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M115.037,155.711c-1.267.144-1.9.218-3.166.374-.027-.222-.043-.335-.07-.558,1.006-.125,1.509-.183,2.515-.3-.07-.6-.105-.9-.175-1.505-1.01.117-1.517.179-2.527.3-.027-.207-.039-.308-.066-.515,1.275-.16,1.918-.234,3.193-.378-.074-.651-.113-.979-.187-1.634-2.051.234-3.076.359-5.123.624.3,2.336.456,3.5.76,5.833,2.008-.261,3.014-.386,5.03-.612-.074-.655-.109-.983-.187-1.634Z",
    transform: "translate(-66.763 -92.43)",
    fill: "#fff"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M134.806,149.62c-.951.086-1.427.129-2.374.222-.675,2.429-1,3.646-1.642,6.079.8-.082,1.193-.125,1.988-.2.086-.37.129-.554.218-.924.866-.082,1.3-.125,2.168-.2.16.347.238.519.394.866.8-.07,1.193-.105,1.992-.172-1.08-2.273-1.63-3.4-2.741-5.665Zm-1.458,3.751c.179-.714.265-1.068.444-1.782.308.667.46,1,.768,1.669C134.077,153.3,133.835,153.324,133.348,153.371Z",
    transform: "translate(-79.795 -91.283)",
    fill: "#fff"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M157.42,147.784c-2.125.125-3.186.195-5.31.355.058.76.086,1.139.144,1.9.655-.051.983-.074,1.638-.121.109,1.591.168,2.382.281,3.969.788-.055,1.185-.082,1.977-.133-.1-1.591-.152-2.382-.253-3.973.655-.043.983-.062,1.638-.1-.043-.76-.066-1.139-.113-1.9Z",
    transform: "translate(-92.802 -90.16)",
    fill: "#fff"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M175.856,147.13c-.807.031-1.209.051-2.016.09.113,2.351.172,3.525.285,5.876.792-.039,1.185-.055,1.977-.09C176,150.655,175.953,149.477,175.856,147.13Z",
    transform: "translate(-106.06 -89.764)",
    fill: "#fff"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M194.427,152.354c-.023-2.351-.035-3.529-.058-5.884-.807.008-1.213.016-2.02.027.02,1.142.027,1.712.047,2.854-1-1.123-1.505-1.684-2.523-2.8l-1.743.047c.07,2.351.109,3.529.179,5.88.792-.023,1.189-.035,1.981-.055-.027-1.142-.039-1.712-.066-2.854,1.006,1.119,1.505,1.68,2.5,2.807.682-.012,1.025-.016,1.708-.023Z",
    transform: "translate(-114.778 -89.361)",
    fill: "#fff"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M216.07,152.288c.105-.012.2-.012.308-.027.152-.027.3-.07.448-.105.1-.023.2-.043.292-.07.16-.051.3-.113.445-.172.074-.031.16-.055.23-.09a3.021,3.021,0,0,0,.53-.312c.02-1.084.031-1.626.055-2.706-1.189-.023-1.786-.031-2.975-.043,0,.491-.008.737-.012,1.228.483,0,.729.008,1.213.016,0,.179,0,.269-.008.448a3.555,3.555,0,0,1-.429.1c-.043.008-.078.008-.121.012a2.3,2.3,0,0,1-.265.023,1.219,1.219,0,0,1-1.349-1.283,1.5,1.5,0,0,1,.1-.55c.02-.055.062-.086.09-.136a.609.609,0,0,1,.335-.363,1.113,1.113,0,0,1,.246-.148,1.294,1.294,0,0,1,.214-.035,1.546,1.546,0,0,1,.3-.047,2.585,2.585,0,0,1,1.525.472c.37-.569.558-.854.928-1.419a4.262,4.262,0,0,0-2.48-.8c-.129,0-.253.016-.382.027-.105.008-.211.008-.312.023-.117.019-.222.051-.331.078s-.195.039-.289.07a2.99,2.99,0,0,0-.3.133c-.086.039-.175.07-.257.117-.1.055-.179.125-.269.187a2.209,2.209,0,0,0-.218.156,2.638,2.638,0,0,0-.226.242c-.058.062-.121.121-.175.191a2.319,2.319,0,0,0-.175.3,2.424,2.424,0,0,0-.125.218,3.324,3.324,0,0,0-.129.394,2.01,2.01,0,0,0-.062.2,3.412,3.412,0,0,0-.066.675,3.025,3.025,0,0,0,3.256,3.037,4.394,4.394,0,0,0,.441-.039Z",
    transform: "translate(-129.567 -89.245)",
    fill: "#fff"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M250.717,153.452c.8.047,1.2.07,2,.125.008-.109.012-.16.019-.269-.433-.421-.647-.632-1.08-1.049a8.57,8.57,0,0,0,1.318-1.189c-.526-.448-.791-.671-1.322-1.115a6.851,6.851,0,0,1-1.189,1.162l-.663-.636c.85-.257,1.567-.768,1.614-1.564.055-.912-.71-1.536-2.211-1.614-.16-.008-.3,0-.444,0-.082,0-.16.008-.238.012a2.494,2.494,0,0,0-.261.035c-.07.012-.136.023-.2.039-.078.019-.148.043-.214.066s-.113.039-.164.058a1.776,1.776,0,0,0-.172.094c-.043.027-.09.051-.129.078a1.37,1.37,0,0,0-.136.121,1.058,1.058,0,0,0-.094.094,1.247,1.247,0,0,0-.1.148c-.019.035-.043.062-.062.1a1.461,1.461,0,0,0-.066.183.879.879,0,0,0-.031.094,1.858,1.858,0,0,0-.043.3c-.023.546.608,1.228.589,1.306-.008.031-1.423.733-1.454,1.466-.043,1.01.78,1.747,2.172,1.817.125.008.246,0,.367,0a5.378,5.378,0,0,0,.85-.078l.117-.023a5.018,5.018,0,0,0,.792-.218C250.46,153.175,250.545,153.268,250.717,153.452Zm-2.051-1.63c-.468-.023-.636-.292-.624-.534a.51.51,0,0,1,.265-.359c.328.339.491.507.815.85a1.7,1.7,0,0,1-.456.047Zm.807-2.46a.672.672,0,0,1-.051.058.647.647,0,0,1-.1.105.726.726,0,0,1-.07.047.854.854,0,0,1-.109.07.25.25,0,0,1-.066.02.271.271,0,0,1-.117.019.645.645,0,0,1-.265-.5.282.282,0,0,1,.109-.211c.02-.016.062-.016.09-.027a.484.484,0,0,1,.226-.055c.32.016.429.16.425.3a.338.338,0,0,1-.07.168Z",
    transform: "translate(-150.076 -89.867)",
    fill: "#fff"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M284.778,156.05c.8.082,1.193.125,1.988.211-.628-2.437-.951-3.653-1.614-6.086-.951-.1-1.423-.144-2.375-.234-1.123,2.258-1.677,3.388-2.768,5.657.8.07,1.193.105,1.992.179l.39-.869c.866.082,1.3.125,2.168.214.09.37.133.558.222.928Zm-1.77-2.472c.308-.667.464-1,.772-1.665.175.714.261,1.068.437,1.782-.483-.051-.725-.074-1.209-.121Z",
    transform: "translate(-170.834 -91.478)",
    fill: "#fff"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M307.112,152.226c-.8-.1-1.2-.148-2.008-.246-.277,2.336-.417,3.505-.694,5.841.788.094,1.181.14,1.969.242C306.671,155.727,306.82,154.561,307.112,152.226Z",
    transform: "translate(-185.72 -92.723)",
    fill: "#fff"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M323.475,160.47a2.662,2.662,0,0,0,.55.023,1.1,1.1,0,0,0,.117-.008,2.327,2.327,0,0,0,.425-.074c.02-.6.031-.893.051-1.489a1.545,1.545,0,0,1-.238.008,2.173,2.173,0,0,1-.339-.027,3,3,0,0,1-1.271-.877s1.505-.628,1.634-1.447a2.038,2.038,0,0,0-1.907-2.293c-1.341-.2-2.012-.292-3.357-.476-.32,2.332-.48,3.5-.8,5.825.788.109,1.177.164,1.965.277.113-.776.168-1.166.281-1.942.749.737,1.528,2.293,2.885,2.5Zm-1.423-3.739a.461.461,0,0,1-.078.016.523.523,0,0,1-.175,0c-.406-.058-.6-.09-1.01-.148.051-.355.078-.534.129-.889.406.058.608.086,1.014.148a.451.451,0,0,1,.421.519.418.418,0,0,1-.051.148.337.337,0,0,1-.027.039.484.484,0,0,1-.07.086c-.016.012-.035.023-.055.035a.449.449,0,0,1-.1.047Z",
    transform: "translate(-194.219 -93.839)",
    fill: "#fff"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M398.9,57.939l.573.686h.105l.573-.686V59.1h.616V56.96h-.519l-.725.846-.721-.846h-.519V59.1h.616Z",
    transform: "translate(-242.99 -34.751)",
    fill: "#fff"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M392.9,59.1h.624V57.584h.6V56.96H392.3v.624h.6Z",
    transform: "translate(-239.342 -34.751)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1712);
export default __webpack_public_path__ + "static/media/logo_1712.6eabdb8047d30b96d7e3aeff9b6f8a3e.svg";
export { ForwardRef as ReactComponent };